import React from "react"

export const AD = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFE100"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#0006AB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#D20636"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.936 9.935C12.55 9.748 13 9.177 13 8.5V5.5C13 4.665 12.328 4 11.5 4H9.5C8.674 4 8 4.67 8 5.5V8.5C8 9.182 8.448 9.75 9.064 9.936C9.25 10.556 9.822 11 10.5 11C11.182 11 11.75 10.55 11.936 9.935Z"
                    fill="#C8B47C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 5H10V6.5H9V5ZM11 7H12V8.5H11V7Z"
                    fill="#D20636"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 5H12V6.5H11V5ZM9 7H10V8.5H9V7Z"
                    fill="#FFE100"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#007E35"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V15H6V0H0Z"
                    fill="#FF0400"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AF = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#C10000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#009B00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 10C11.88 10 13 8.88 13 7.5C13 6.12 11.88 5 10.5 5C9.12 5 8 6.12 8 7.5C8 8.88 9.12 10 10.5 10ZM10.5 9C11.328 9 12 8.105 12 7C12 5.895 11.328 5 10.5 5C9.672 5 9 5.895 9 7C9 8.105 9.672 9 10.5 9ZM10.5 8C10.776 8 11 7.552 11 7C11 6.448 10.776 6 10.5 6C10.224 6 10 6.448 10 7C10 7.552 10.224 8 10.5 8Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="black"
                />
                <path
                    d="M10.5 9C12.433 9 14 7.433 14 5.5C14 3.567 12.433 2 10.5 2C8.567 2 7 3.567 7 5.5C7 7.433 8.567 9 10.5 9Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 9H21V15H0V9Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 6H21V9H0V6Z"
                    fill="#0070C9"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 15H0V0L11 15Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 15H21V0L10 15Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AL = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#E71910"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 4L9 3L8 4H9L8 5L6 4V9L9 8L8 10H7L8 11L9 10L10.5 12V4ZM12 3L13 4H12L13 5L15 4V9L12 8L13 10H14L13 11L12 10L10.5 12V4L12 3Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#002EA3"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#F4A900"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#DC0000"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path d="M13 0H8V15H13V0Z" fill="#DC171D" />
                <path d="M21 5H0V10H21V5Z" fill="#012A87" />
                <path d="M8 7H7V8H8V7Z" fill="white" />
                <path d="M10 8H9V9H10V8Z" fill="white" />
                <path d="M12 8H11V9H12V8Z" fill="white" />
                <path d="M14 7H13V8H14V7Z" fill="white" />
                <path d="M11 6H10V7H11V6Z" fill="white" />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AO = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V15H0V8Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.31 9.58598C13.744 9.00398 14 8.28198 14 7.49998C14 6.03298 13.097 4.77698 11.817 4.25598L11.212 5.10298C12.246 5.40998 13 6.36698 13 7.49998C13 8.09398 12.793 8.63998 12.447 9.06798L9.00001 6.99998L11.696 9.69598C11.341 9.88998 10.933 9.99998 10.5 9.99998C9.66001 9.99998 8.91701 9.58598 8.46401 8.94998L7.85901 9.79698C8.50001 10.534 9.44501 11 10.5 11C11.21 11 11.872 10.788 12.424 10.424L13 11L14 9.99998L13.31 9.58598ZM9.00001 4.99998H10V5.99998H9.00001V4.99998Z"
                    fill="#FAD800"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10ZM0 0H21V5H0V0Z"
                    fill="#72ABE1"
                />
                <path
                    d="M10.5 9C11.3284 9 12 8.32843 12 7.5C12 6.67157 11.3284 6 10.5 6C9.67157 6 9 6.67157 9 7.5C9 8.32843 9.67157 9 10.5 9Z"
                    fill="#F8B500"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AT = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10ZM0 0H21V5H0V0Z"
                    fill="#F02532"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AU = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00008E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 11.5L5 11L5.5 10L6 11L7 11.5L6 12L5.5 13L5 12L4 11.5ZM14 3V4H15V3H14ZM17 4V5H18V4H17ZM13 6V7H14V6H13ZM16 7V8H17V7H16ZM15 10V11H16V10H15Z"
                    fill="#BDC4E7"
                />
                <path
                    d="M9 1H2C1.44772 1 1 1.44772 1 2V7C1 7.55228 1.44772 8 2 8H9C9.55229 8 10 7.55228 10 7V2C10 1.44772 9.55229 1 9 1Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 5H2V4H5V2H6V4H9V5H6V7H5V5ZM7.5 6V7H9V6H7.5ZM7.5 2V3H9V2H7.5ZM2 6V7H3.5V6H2ZM2 2V3H3.5V2H2Z"
                    fill="#FF0000"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AW = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#3D87E0"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.485 4.485C5.355 4.43 6 4.235 6 4C6 3.766 5.355 3.57 4.485 3.515C4.43 2.645 4.235 2 4 2C3.766 2 3.57 2.645 3.515 3.515C2.645 3.57 2 3.765 2 4C2 4.234 2.645 4.43 3.515 4.485C3.57 5.355 3.765 6 4 6C4.234 6 4.43 5.355 4.485 4.485Z"
                    fill="#D4062F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.485 4.485C5.355 4.43 6 4.235 6 4C6 3.766 5.355 3.57 4.485 3.515C4.43 2.645 4.235 2 4 2C3.766 2 3.57 2.645 3.515 3.515C2.645 3.57 2 3.765 2 4C2 4.234 2.645 4.43 3.515 4.485C3.57 5.355 3.765 6 4 6C4.234 6 4.43 5.355 4.485 4.485ZM4.515 4.985L4.985 4.515C4.91 5.713 4.66 6.5 4 6.5C3.34 6.5 3.09 5.712 3.016 4.516L3.484 4.984C2.288 4.91 1.5 4.66 1.5 4C1.5 3.34 2.288 3.09 3.484 3.016L3.016 3.484C3.09 2.288 3.34 1.5 4 1.5C4.66 1.5 4.91 2.288 4.984 3.484L4.516 3.016C5.712 3.09 6.5 3.34 6.5 4C6.5 4.66 5.712 4.91 4.516 4.984L4.515 4.985Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 9H21V10H0V9ZM0 11H21V12H0V11Z"
                    fill="#FAD800"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const AZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#E3002E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#00AF62"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#0097C5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7H13V8H12V7Z"
                    fill="#FBDCE2"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 9C12.044 9.607 11.318 10 10.5 10C9.12 10 8 8.88 8 7.5C8 6.12 9.12 5 10.5 5C11.318 5 12.044 5.393 12.5 6H11C10.172 6 9.5 6.672 9.5 7.5C9.5 8.328 10.172 9 11 9H12.5Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFCC00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L21 14L20.877 15.1L0 15V0Z"
                    fill="#001C98"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 3H2V4H1V3ZM4 5H5V6H4V5ZM7 7H8V8H7V7ZM10 9H11V10H10V9ZM13 11H14V12H13V11ZM16 13H17V14H16V13Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BB = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFC800"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0ZM14 0H21V15H14V0Z"
                    fill="#002281"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 10H11V11H10V10ZM12 8H13V9H12V8ZM8 8H9V9H8V8Z"
                    fill="#7F6300"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 8V4H10V8H9V9H10V10H11V9H12V8H11ZM12 5H13V8H12V5ZM8 5H9V8H8V5Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BD = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#006B4D"
                />
                <path
                    d="M9.5 12C11.9853 12 14 9.98528 14 7.5C14 5.01472 11.9853 3 9.5 3C7.01472 3 5 5.01472 5 7.5C5 9.98528 7.01472 12 9.5 12Z"
                    fill="#F7253B"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FBE22B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#F02532"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BF = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#F22722"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V15H0V8Z"
                    fill="#009F45"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 9.25L8.44298 10.332L8.83598 8.042L7.16998 6.417L9.46998 6.083L10.5 4L11.53 6.084L13.83 6.418L12.164 8.041L12.557 10.333"
                    fill="#FDD200"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00976D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#D82300"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BH = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FBE22B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10ZM0 0H21V5H0V0Z"
                    fill="#00ABCB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V15.033L11 7.5L0 0Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BI = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L10 8L0 15V0ZM21 0L11 8L21 15V0Z"
                    fill="#08B731"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.158 6.456L0 1.5V0H1.5L8.347 4.74C8.94 4.276 9.687 4 10.5 4C11.312 4 12.06 4.276 12.653 4.74L19.5 0H21V1.5L13.842 6.456C13.945 6.786 14 7.136 14 7.5C14 7.864 13.945 8.214 13.842 8.544L21 13.5V15H19.5L12.653 10.26C12.059 10.724 11.313 11 10.5 11C9.688 11 8.94 10.724 8.347 10.26L1.5 15H0V13.5L7.158 8.544C7.055 8.214 7 7.864 7 7.5C7 7.136 7.055 6.786 7.158 6.456Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 6H11V7H10V6ZM11 8H12V9H11V8ZM9 8H10V9H9V8Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BJ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 8H21V15H8V8Z"
                    fill="#EB0624"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H8V15H0V0Z"
                    fill="#00884F"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#F8E200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L21 10V14L0 4V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 3L21 13V15L0 5V3Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 7L9 8V12L7 11V9L5 7L7 5L8 6V7ZM9 9H12V10H9V9ZM13 7L12 8V12L14 11V9L16 7L14 5L13 6V7ZM9 6H12L10.5 3L9 6Z"
                    fill="#D1091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BO = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFE200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7H10V8H9V7ZM11 7H12V8H11V7Z"
                    fill="#009BBE"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7H13V9H12V7ZM11 6H12V7H11V6ZM9 6H10V7H9V6ZM8 7H9V9H8V7Z"
                    fill="#D7280F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 8H11V9H10V8Z"
                    fill="#007B30"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 6H11V7H10V6Z"
                    fill="#3F291F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 8H12V9H11V8ZM9 8H10V9H9V8Z"
                    fill="#EAA400"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 7H11V8H10V7Z"
                    fill="#3B5B27"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#007A30"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D7280F"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#009C34"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 2L18 7.5L10.5 13L3 7.5"
                    fill="#F8E23D"
                />
                <path
                    d="M10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z"
                    fill="#002478"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9V10H10V9H9ZM11 9V10H12V9H11Z"
                    fill="#91A1C3"
                />
                <path
                    d="M8 6C8 6 10.264 6.4 11.896 7.098L14 8"
                    stroke="#C9D0E0"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BS = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0ZM7 0L9 1.5L7 3V0ZM7 3L9 4.5L7 6V3ZM7 6L9 7.5L7 9V6ZM7 9L9 10.5L7 12V9ZM7 12L9 13.5L7 15V12Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BT = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FF4D00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L21 0H0V15Z"
                    fill="#FFD700"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 10L3.5 11.5L5.5 12L6 11L10 11.5L9 9H11L14 10L15 9L12 8L13 7H16L16.5 6H14V5H16L17 4L13 3L11 5L10 6L11 7L8 6.5L6 10L5 11L3 10Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BV = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#F22722"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 9H0V6H6V0H9V6H21V9H9V15H6V9Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 8H0V7H7V0H8V7H21V8H8V15H7V8Z"
                    fill="#00256A"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BW = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#73A9DD"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 9H21V10H0V9Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 6H21V9H0V6Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5H21V6H0V5Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BY = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 0L5 1.5L3 3V0ZM3 3L5 4.5L3 6V3ZM3 6L5 7.5L3 9V6ZM3 9L5 10.5L3 12V9ZM3 12L5 13.5L3 15V12ZM2 0L0 1.5L2 3V0ZM2 3L0 4.5L2 6V3ZM2 6L0 7.5L2 9V6ZM2 9L0 10.5L2 12V9ZM2 12L0 13.5L2 15V12ZM2 0H3V2H2V0ZM2 13H3V15H2V13ZM2 5H3V7H2V5ZM2 3H3V4H2V3ZM2 11H3V12H2V11ZM2 8H3V10H2V8Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 11H21V15H5V11Z"
                    fill="#46A753"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const BZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#003D89"
                />
                <path
                    d="M10.5 12C12.9853 12 15 9.98528 15 7.5C15 5.01472 12.9853 3 10.5 3C8.01472 3 6 5.01472 6 7.5C6 9.98528 8.01472 12 10.5 12Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.5 8H12.5V9H8.5V8Z"
                    fill="#CBCBCB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 5H9V6H8V5ZM10 4H11V5H10V4ZM12 5H13V6H12V5ZM13 7H14V8H13V7ZM12 9H13V10H12V9Z"
                    fill="#5E9F47"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 6H12V7H11V6Z"
                    fill="#580A00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 7H12V8H11V7Z"
                    fill="#B54B00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6H10V7H9V6Z"
                    fill="#BD6100"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7H10V8H9V7Z"
                    fill="#F9B626"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 10H11V11H10V10ZM8 9H9V10H8V9ZM7 7H8V8H7V7Z"
                    fill="#5E9F47"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 13H21V15H0V13ZM0 0H21V2H0V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H5V15H0V0ZM16 0H21V15H16V0ZM10.5 4L9.5 6L8 5V7L7 8L9 9H10V11H11V9H12L14 8L13 7V5L11.4 6L10.5 4Z"
                    fill="#FF0000"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CD = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#007BFF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.498 5.23L3.028 6.003L3.308 4.366L2.12 3.206L3.763 2.969L4.498 1.479L5.232 2.969L6.875 3.206L5.685 4.366L5.967 6.002"
                    fill="#FFE000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 14L21 3V-1L0 10V14Z"
                    fill="#F8D800"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 16L21 5V1L0 12V16Z"
                    fill="#F8D800"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L21 4V0L0 11V15Z"
                    fill="#D00817"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CF = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V11H0V8Z"
                    fill="#20981D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#002D84"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 2H4V3H3V2Z"
                    fill="#FFCF00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 2H3V3H2V2ZM4 2H5V3H4V2ZM3 3H4V4H3V3ZM3 1H4V2H3V1Z"
                    fill="#A7972D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 0H12V15H9V0Z"
                    fill="#D4062E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00963F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 15L19 0H21V15H6Z"
                    fill="#DE2110"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 15L21 0H14L0 15H7Z"
                    fill="#FCDF37"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CH = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FF0400"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6H6V9H9V12H12V9H15V6H12V3H9V6Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CI = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#F97F00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#009F5E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CL = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H9V8H0V0Z"
                    fill="#0034A9"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.50001 5.22701L3.03001 6.00001L3.31001 4.36401L2.12201 3.20401L3.76501 2.96601L4.50001 1.47601L5.23501 2.96601L6.87801 3.20601L5.68801 4.36401L5.97001 6.00001"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V15H0V8Z"
                    fill="#D7280F"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 8.75L9.03001 9.523L9.31001 7.886L8.12201 6.726L9.76501 6.489L10.5 5L11.235 6.49L12.878 6.727L11.688 7.887L11.968 9.523"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#007B5D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#FDD200"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#E02600"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.498 7.23L4.028 8.003L4.308 6.366L3.12 5.206L4.763 4.969L5.498 3.479L6.232 4.969L7.875 5.206L6.685 6.366L6.967 8.002L5.498 7.23ZM9 3H10V4H9V3ZM10 5H11V6H10V5ZM10 7H11V8H10V7ZM9 9H10V10H9V9Z"
                    fill="#FFE000"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CO = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#003495"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V7H0V0Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#003495"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 3H21V5H0V3Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5H21V10H0V5Z"
                    fill="#D11C1F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V12H0V10Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CU = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#003495"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 3H21V6H0V3ZM0 9H21V12H0V9Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L12 7.5L0 15V0Z"
                    fill="#D10D24"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.49995 8.75L3.02995 9.523L3.30995 7.886L2.12195 6.726L3.76495 6.489L4.49995 5L5.23495 6.49L6.87795 6.727L5.68795 7.887L5.96795 9.523"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CV = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#003495"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V9H0V8Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 9H21V10H0V9Z"
                    fill="#D11C1F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V11H0V10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 7H6V8H5V7ZM7 6H8V7H7V6ZM9 7H10V8H9V7ZM10 9H11V10H10V9ZM4 9H5V10H4V9ZM9 11H10V12H9V11ZM7 12H8V13H7V12ZM5 11H6V12H5V11Z"
                    fill="#F8D300"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CW = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#002B7F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 5H4.49539C4.21575 5 4 5.22386 4 5.5C4 5.76807 4.22179 6 4.49539 6H5V6.50461C5 6.78425 5.22386 7 5.5 7C5.76807 7 6 6.77821 6 6.50461V6H6.50461C6.78425 6 7 5.77614 7 5.5C7 5.23193 6.77821 5 6.50461 5H6V4.49539C6 4.21575 5.77614 4 5.5 4C5.23193 4 5 4.22179 5 4.49539V5ZM3 3H4V4H3V3Z"
                    fill="white"
                />
                <path d="M21 9H0V11H21V9Z" fill="#F9E814" />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CY = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6C5 6 6 9 9 9C12 9 15 6 15 6H13L16 3L10 5L8 3L7 5L5 6Z"
                    fill="#DA7500"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 9L10 11V12L4 10L5 9ZM16 9L11 11V12L17 10L16 9ZM10 11H11V13H10V11Z"
                    fill="#435121"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const CZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D90D08"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V7H0V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L10 7.5L0 15V0Z"
                    fill="#0B4380"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const DE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#E00000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#FFCF00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const DJ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00AF1E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V8H0V0Z"
                    fill="#67B1E9"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L12 7.5L0 15V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.50001 8.75L3.03001 9.523L3.31001 7.886L2.12201 6.726L3.76501 6.489L4.50001 5L5.23501 6.49L6.87801 6.727L5.68801 7.887L5.96801 9.523"
                    fill="#D90D08"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const DK = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#C8032B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 9H0V6H6V0H9V6H21V9H9V15H6V9Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const DM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#006C3D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 7H0V8H10V15H11V8H21V7H11V0H10V7Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6V7H10V0H9V6H0V7H10V6H9ZM10 7H21V6H9V7H10V6H9V15H10V7Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 9V8H11V15H12V9H21V8H11V9H12ZM0 8H13V9H0V8ZM11 0H12V9H11V0Z"
                    fill="white"
                />
                <path
                    d="M10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z"
                    fill="#D6172A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6H10V7H9V6ZM11 6H12V7H11V6ZM11 8H12V9H11V8ZM9 8H10V9H9V8Z"
                    fill="#006C3D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 6H11V8H10V6Z"
                    fill="#955DCC"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const DO = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#002B64"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 9H9V15H0V9ZM12 0H21V6H12V0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9H0V6H9V0H12V6H21V9H12V15H9V9Z"
                    fill="white"
                />
                <path
                    d="M10.5 9C11.3284 9 12 8.32843 12 7.5C12 6.67157 11.3284 6 10.5 6C9.67157 6 9 6.67157 9 7.5C9 8.32843 9.67157 9 10.5 9Z"
                    fill="#007A1B"
                />
                <path
                    d="M10.5 8C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7C10.2239 7 10 7.22386 10 7.5C10 7.77614 10.2239 8 10.5 8Z"
                    fill="#002B64"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.5 7C9.776 7 10 6.776 10 6.5C10 6.224 9.776 6 9.5 6C9.224 6 9 6.224 9 6.5C9 6.776 9.224 7 9.5 7ZM11.5 7C11.776 7 12 6.776 12 6.5C12 6.224 11.776 6 11.5 6C11.224 6 11 6.224 11 6.5C11 6.776 11.224 7 11.5 7Z"
                    fill="#FDD200"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const DZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H10V15H0V0Z"
                    fill="#357C58"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.052 10.263C12.23 11.32 10.944 12 9.5 12C7.015 12 5 9.985 5 7.5C5 5.015 7.015 3 9.5 3C10.944 3 12.23 3.68 13.052 4.737C12.417 4.275 11.618 4 10.75 4C8.68 4 7 5.567 7 7.5C7 9.433 8.68 11 10.75 11C11.618 11 12.417 10.725 13.052 10.263Z"
                    fill="#E82E2E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 7.5L14 7L14.5 6L15 7L16 7.5L15 8L14.5 9L14 8L13 7.5Z"
                    fill="#E82E2E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const EC = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#004BA5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#F01616"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V8H0V0Z"
                    fill="#FFDF00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 4H9L10.5 5L12 4H15L12 5L11 6H10L9 5L6 4Z"
                    fill="#3D2620"
                />
                <path
                    d="M10.5 10C11.3284 10 12 9.10457 12 8C12 6.89543 11.3284 6 10.5 6C9.67157 6 9 6.89543 9 8C9 9.10457 9.67157 10 10.5 10Z"
                    fill="#07A7D3"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 7V9L10 10H11L13 9V7L14 9L13 10L11 11H10L8 10L7 9L8 7Z"
                    fill="#FFDF00"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const EE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#448FDC"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const EG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 7L9 6L8 7L9 9L10 8H11L12 9L13 7L12 6L10.5 7Z"
                    fill="#CEAB26"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ER = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#3C87E0"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V8H0V0Z"
                    fill="#00AF1E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L21 7.5L0 15V0Z"
                    fill="#ED0030"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7.49998C9 6.11998 7.88 4.99998 6.5 4.49998C5.12 4.99998 4 6.11998 4 7.49998C4 8.70998 4.86 9.71798 6 9.94998V6.49798C6 6.22298 6.232 5.99998 6.5 5.99998C6.776 5.99998 7 6.21498 7 6.49798V9.94998C8.14 9.71798 9 8.70998 9 7.49998ZM10 7.49998C10 5.56698 8.433 3.99998 6.5 4.49998C4.567 3.99998 3 5.56698 3 7.49998C3 9.43298 4.567 11 6.5 11C8.433 11 10 9.43298 10 7.49998Z"
                    fill="#FFC800"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ES = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#CD0B20"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4H21V11H0V4Z"
                    fill="#FFCB00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6.22197V8.74197C9 9.44197 8.328 10.002 7.5 10.002H5.5C4.674 9.99997 4 9.43697 4 8.73997V6.21997C4 5.64797 4.448 5.16997 5.064 5.01497C5.25 4.49497 5.822 4.96097 6.5 4.96097C7.182 4.96097 7.75 4.49797 7.936 5.01597C8.55 5.17497 9 5.65397 9 6.22197Z"
                    fill="#C8B47C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7H10V10H9V7ZM3 7H4V10H3V7Z"
                    fill="#B5B5B5"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9H10V10H9V9ZM3 9H4V10H3V9Z"
                    fill="#165C96"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6H10V7H9V6ZM3 6H4V7H3V6Z"
                    fill="#A0790A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6H6V7.5H5V6ZM7 8H8V9.5H7V8Z"
                    fill="#D20636"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 6H8V7.5H7V6Z"
                    fill="#A18793"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 8H6V9.5H5V8Z"
                    fill="#FFE100"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 6L5 5H8L7 6H6Z"
                    fill="#B6161A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 4H7V5H6V4Z"
                    fill="#AC9300"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ET = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FDDF00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#DD0A07"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#008A2A"
                />
                <path
                    d="M10.5 12C12.9853 12 15 9.98528 15 7.5C15 5.01472 12.9853 3 10.5 3C8.01472 3 6 5.01472 6 7.5C6 9.98528 8.01472 12 10.5 12Z"
                    fill="#0643B2"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.498 8.75002L9.028 9.52302L9.30799 7.88602L8.12 6.72602L9.76299 6.48902L10.498 4.99902L11.232 6.48902L12.875 6.72602L11.685 7.88602L11.967 9.52202"
                    fill="#FDDF00"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const FI = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 9H0V6H6V0H9V6H21V9H9V15H6V9Z"
                    fill="#003282"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const FJ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#64BEE7"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 10V6.5C18 5.665 17.328 5 16.5 5H14.5C13.674 5 13 5.67 13 6.5V10C13 10.182 14 12 15.5 12C17 12 18 10.177 18 10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 8V9.118H18V10.08H16V12H15V10.08H13V9.118H15V8H13V5H18V8H16Z"
                    fill="#FF0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 6H17V7H14V6Z"
                    fill="#FFD200"
                />
                <path
                    d="M9 1H2C1.44772 1 1 1.44772 1 2V7C1 7.55228 1.44772 8 2 8H9C9.55229 8 10 7.55228 10 7V2C10 1.44772 9.55229 1 9 1Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 5H2V4H5V2H6V4H9V5H6V7H5V5ZM7.5 6V7H9V6H7.5ZM7.5 2V3H9V2H7.5ZM2 6V7H3.5V6H2ZM2 2V3H3.5V2H2Z"
                    fill="#FF0000"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const FM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#72B1DF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 4H9.495C9.215 4 9 4.224 9 4.5C9 4.768 9.222 5 9.495 5H10V5.505C10 5.785 10.224 6 10.5 6C10.768 6 11 5.778 11 5.505V5H11.505C11.785 5 12 4.776 12 4.5C12 4.232 11.778 4 11.505 4H11V3.495C11 3.215 10.776 3 10.5 3C10.232 3 10 3.222 10 3.495V4ZM14 7H13.495C13.215 7 13 7.224 13 7.5C13 7.768 13.222 8 13.495 8H14V8.505C14 8.785 14.224 9 14.5 9C14.768 9 15 8.778 15 8.505V8H15.505C15.785 8 16 7.776 16 7.5C16 7.232 15.778 7 15.505 7H15V6.495C15 6.215 14.776 6 14.5 6C14.232 6 14 6.222 14 6.495V7ZM10 10H9.495C9.215 10 9 10.224 9 10.5C9 10.768 9.222 11 9.495 11H10V11.505C10 11.785 10.224 12 10.5 12C10.768 12 11 11.778 11 11.505V11H11.505C11.785 11 12 10.776 12 10.5C12 10.232 11.778 10 11.505 10H11V9.495C11 9.215 10.776 9 10.5 9C10.232 9 10 9.222 10 9.495V10ZM6 7H5.495C5.215 7 5 7.224 5 7.5C5 7.768 5.222 8 5.495 8H6V8.505C6 8.785 6.224 9 6.5 9C6.768 9 7 8.778 7 8.505V8H7.505C7.785 8 8 7.776 8 7.5C8 7.232 7.778 7 7.505 7H7V6.495C7 6.215 6.776 6 6.5 6C6.232 6 6 6.222 6 6.495V7Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const FR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#001C98"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#F02532"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#3673C7"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#009F5E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GB = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#22438B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 1L0.973999 1.026L0.999999 3L17.982 14.028L20.019 13.991L19.981 12.029L3 1Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 1L1 2L19 14L20 13L2 1Z"
                    fill="#C7152A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 1H20V3C20 3 8.24999 10.396 3.01799 14.028C2.95499 14.072 1.01999 14.031 1.01999 14.031L0.86499 12.13L18 1Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.043 0.971985L20 1.99998L2 14L1 13L19.043 0.971985Z"
                    fill="#C7152A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 1H13V5H20V10H13V14H8V10H1V5H8V1Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 1H12V6H20V9H12V14H9V9H1V6H9V1Z"
                    fill="#C7152A"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GD = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 3H18V12H3V3Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 3L10.5 7.5L3 12V3Z"
                    fill="#007B5D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 7H5V8H4V7Z"
                    fill="#F7BA03"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 3L10.5 7.5L18 12V3Z"
                    fill="#007B5D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 1H8V2H7V1ZM10 1H11V2H10V1ZM13 1H14V2H13V1ZM7 13H8V14H7V13ZM10 13H11V14H10V13ZM13 13H14V14H13V13Z"
                    fill="#F3A906"
                />
                <path
                    d="M10.5 10C11.8807 10 13 8.88071 13 7.5C13 6.11929 11.8807 5 10.5 5C9.11929 5 8 6.11929 8 7.5C8 8.88071 9.11929 10 10.5 10Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 8.75L9.03001 9.523L9.31001 7.886L8.12201 6.726L9.76501 6.489L10.5 5L11.235 6.49L12.878 6.727L11.688 7.887L11.968 9.523"
                    fill="#FDD200"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9H0V6H9V0H12V6H21V9H12V15H9V9Z"
                    fill="#FF0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 11H14V12H15V13H16V12H17V11H16V10H15V11ZM15 3H14V4H15V5H16V4H17V3H16V2H15V3ZM5 3H4V4H5V5H6V4H7V3H6V2H5V3ZM5 11H4V12H5V13H6V12H7V11H6V10H5V11Z"
                    fill="#FF0000"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GH = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#006C3D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 8.75L9.03001 9.523L9.31001 7.886L8.12201 6.726L9.76501 6.489L10.5 5L11.235 6.49L12.878 6.727L11.688 7.887L11.968 9.523"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#387822"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 6H21V9H0V6Z"
                    fill="#09148F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#00955E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GQ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#E61D00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#3A9B00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 7C10.776 7 11 6.776 11 6.5C11 6.224 10.776 6 10.5 6C10.224 6 10 6.224 10 6.5C10 6.776 10.224 7 10.5 7ZM12.5 7C12.776 7 13 6.776 13 6.5C13 6.224 12.776 6 12.5 6C12.224 6 12 6.224 12 6.5C12 6.776 12.224 7 12.5 7ZM14.5 7C14.776 7 15 6.776 15 6.5C15 6.224 14.776 6 14.5 6C14.224 6 14 6.224 14 6.5C14 6.776 14.224 7 14.5 7Z"
                    fill="#FFD900"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.5 8C11.776 8 12 7.776 12 7.5C12 7.224 11.776 7 11.5 7C11.224 7 11 7.224 11 7.5C11 7.776 11.224 8 11.5 8ZM13.5 8C13.776 8 14 7.776 14 7.5C14 7.224 13.776 7 13.5 7C13.224 7 13 7.224 13 7.5C13 7.776 13.224 8 13.5 8Z"
                    fill="#009432"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7H13V9H12V7Z"
                    fill="#A46620"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V15.033L7 7.5L0 0Z"
                    fill="#0071D1"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H4V4H0V0ZM6 0H10V4H6V0ZM0 6H4V10H0V6ZM6 6H10V10H6V6ZM10 0H21V2H10V0ZM10 4H21V6H10V4Z"
                    fill="#005CB2"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V10H0V8ZM4 8H6V10H4V8ZM0 12H21V14H0V12Z"
                    fill="#005CB2"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GT = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 7.5C13 6.12 11.88 5 10.5 5C9.12 5 8 6.12 8 7.5C8 8.88 9.12 10 10.5 10C11.88 10 13 8.88 13 7.5ZM10.5 9C11.328 9 12 8.105 12 7C12 5.895 11.328 5 10.5 5C9.672 5 9 5.895 9 7C9 8.105 9.672 9 10.5 9Z"
                    fill="#406421"
                />
                <path
                    d="M10.5 8C10.7761 8 11 7.55228 11 7C11 6.44772 10.7761 6 10.5 6C10.2239 6 10 6.44772 10 7C10 7.55228 10.2239 8 10.5 8Z"
                    fill="#D5B852"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0ZM14 0H21V15H14V0Z"
                    fill="#4596D2"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GW = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V15H0V8Z"
                    fill="#009F45"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H8V15H0V0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.49995 8.75L3.02995 9.523L3.30995 7.886L2.12195 6.726L3.76495 6.489L4.49995 5L5.23495 6.49L6.87795 6.727L5.68795 7.887L5.96795 9.523"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const GY = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#009F45"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15V0H3L21 6V9L3 15H0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L21 7.5L0 15V0Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15V0H1L11 7.5L1 15H0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L10 7.5L0 15V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const HK = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#DE2910"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.155 7.51398C7.44302 6.36598 8.64502 2.82998 11.24 3.00598C10.714 3.27598 10.638 3.77998 10.938 4.24598C11.274 4.76998 10.908 5.61098 10.454 5.81598C9.70802 6.15098 9.55902 7.04598 10.154 7.51398H10.155ZM10.382 7.39198C10.635 4.45898 14.372 4.50898 15.002 7.02998C14.584 6.61498 14.082 6.69798 13.73 7.12798C13.337 7.60798 12.424 7.51798 12.09 7.15098C11.54 6.54698 10.64 6.68098 10.382 7.39298V7.39198ZM10.474 7.68498C13.354 7.06998 14.398 10.657 12.171 11.999C12.447 11.476 12.221 11.019 11.707 10.809C11.133 10.573 10.951 9.67398 11.205 9.24698C11.623 8.54398 11.231 7.72398 10.475 7.68398L10.474 7.68498ZM6.75002 10.98C7.33002 11.08 7.69502 10.723 7.73602 10.17C7.78302 9.54998 8.58102 9.09998 9.06602 9.20998C9.86402 9.38998 10.523 8.76398 10.326 8.03198C11.802 10.582 8.71302 12.682 6.74902 10.979L6.75002 10.98ZM6.15302 5.49998C6.26802 6.07798 6.73102 6.28998 7.26302 6.12998C7.85802 5.95198 8.56502 6.53598 8.63602 7.02998C8.75402 7.83798 9.57402 8.22798 10.186 7.78398C8.33602 10.074 5.26602 7.94398 6.15302 5.49898V5.49998Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const HN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10ZM7 6H8V7H7V6ZM7 8H8V9H7V8ZM13 6H14V7H13V6ZM13 8H14V9H13V8ZM10 7H11V8H10V7ZM0 0H21V5H0V0Z"
                    fill="#0070D2"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const HR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#150A99"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#FF0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4H9V5H8V4ZM10 3H11V5H10V3ZM12 4H13V5H12V4Z"
                    fill="#0091E0"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 3H12V5H11V3ZM9 3H10V5H9V3Z"
                    fill="#150A99"
                />
            </g>
            <mask
                id="mask1"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="8"
                y="5"
                width="5"
                height="6"
            >
                <path
                    d="M13 8.5C13 9.88 11.88 11 10.5 11C9.12 11 8 9.88 8 8.5V5H13V8.5Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask1)">
                <path
                    d="M13 8.5C13 9.88 11.88 11 10.5 11C9.12 11 8 9.88 8 8.5V5H13V8.5Z"
                    fill="#FF0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 10H10V11H9V10ZM11 10H12V11H11V10ZM10 9H11V10H10V9ZM9 8H10V9H9V8ZM11 8H12V9H11V8ZM10 7H11V8H10V7ZM9 6H10V7H9V6ZM11 6H12V7H11V6ZM10 5H11V6H10V5ZM12 5H13V6H12V5ZM12 7H13V8H12V7ZM12 9H13V10H12V9ZM8 9H9V10H8V9ZM8 7H9V8H8V7ZM8 5H9V6H8V5Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const HT = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D4062E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V8H0V0Z"
                    fill="#0017A2"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 6H13V9H8V6Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 7H11V9H10V7Z"
                    fill="#F2B600"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7.5C9 6.672 9.666 6 10.5 6C11.328 6 12 6.666 12 7.5V9H9V7.5ZM10 7.505C10 7.225 10.232 7 10.5 7C10.776 7 11 7.214 11 7.505V9H10V7.505Z"
                    fill="#1C672C"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const HU = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#41704C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#CF273A"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ID = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V8H0V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const IE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#009C44"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#FF7900"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const IL = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V13H0V11ZM0 2H21V4H0V2ZM9.875 9H8L8.938 7.5L8 6H9.875L10.5 5L11.125 6H13L12.062 7.5L13 9H11.125L10.5 10L9.875 9ZM9.5 7.5L10.5 6.5L11.5 7.5L10.5 8.5L9.5 7.5Z"
                    fill="#0031BB"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const IN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 10C11.88 10 13 8.88 13 7.5C13 6.12 11.88 5 10.5 5C9.12 5 8 6.12 8 7.5C8 8.88 9.12 10 10.5 10ZM10.5 9C11.328 9 12 8.328 12 7.5C12 6.672 11.328 6 10.5 6C9.672 6 9 6.672 9 7.5C9 8.328 9.672 9 10.5 9Z"
                    fill="#00008A"
                />
                <path
                    d="M10.5 8C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7C10.2239 7 10 7.22386 10 7.5C10 7.77614 10.2239 8 10.5 8Z"
                    fill="#00008A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#018900"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#FF991E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const IQ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 8H11V8.495C11 8.785 11.224 9 11.5 9C11.768 9 12 8.774 12 8.495V6.495C12 6.222 12.232 6 12.5 6C12.776 6 13 6.216 13 6.495V8H14.49C14.772 8 15 8.232 15 8.5C15 8.776 14.778 9 14.49 9H6.51C6.228 9 6 8.768 6 8.5C6 8.288 6.13 8.107 6.32 8.034C6.345 7.97 6.383 7.909 6.436 7.857L7.856 6.437C8.05 6.243 8.371 6.25 8.561 6.439C8.757 6.634 8.763 6.944 8.565 7.142L7.707 8H9V7.505C9 7.225 9.232 7 9.5 7C9.776 7 10 7.214 10 7.505V8Z"
                    fill="#007B3A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const IR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 9C11.88 9 13 8.328 13 7.5C13 6.672 11.88 6 10.5 6C9.12 6 8 6.672 8 7.5C8 8.328 9.12 9 10.5 9ZM10.5 8.25C11.328 8.25 12 7.746 12 7.125C12 6.505 11.328 6 10.5 6C9.672 6 9 6.504 9 7.125C9 7.745 9.672 8.25 10.5 8.25Z"
                    fill="#DD0000"
                />
                <path
                    d="M10.5 8C10.7761 8 11 7.55228 11 7C11 6.44772 10.7761 6 10.5 6C10.2239 6 10 6.44772 10 7C10 7.55228 10.2239 8 10.5 8Z"
                    fill="#DD0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#DD0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#17A03A"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const IS = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#003499"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 9H0V6H6V0H9V6H21V9H9V15H6V9Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 7H0V8H7V15H8V8H21V7H8V0H7V7Z"
                    fill="#D9251E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const IT = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#009342"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#D02832"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const JM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#009C34"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L10 8L0 15V0ZM21 0L11 8L21 15V0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.667 7.5L0 1.5V0H1.5L10.5 6.23L19.5 0H21V1.5L12.333 7.5L21 13.5V15H19.5L10.5 8.77L1.5 15H0V13.5L8.667 7.5Z"
                    fill="#FFD300"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const JO = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#007B3A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V15.033L13 7.5L0 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 7.5L4 7L4.5 6L5 7L6 7.5L5 8L4.5 9L4 8L3 7.5Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const JP = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    d="M10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z"
                    fill="#BE0028"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const KE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V11H0V10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#006700"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5H21V10H0V5Z"
                    fill="#BD0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4H21V5H0V4Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.414 5.914C12.486 5.914 12.914 5.244 12.914 4.414C12.914 3.586 12.486 2.914 12.414 2.914C12.344 2.914 11.914 3.586 11.914 4.414C11.914 5.244 12.344 5.914 12.414 5.914ZM9.47504 5.475C9.42504 5.525 8.64504 5.355 8.06104 4.768C7.47604 4.182 7.30404 3.404 7.35504 3.354C7.40504 3.304 8.18304 3.474 8.76904 4.061C9.35504 4.647 9.52604 5.425 9.47604 5.476L9.47504 5.475ZM11.354 10.008C11.404 9.961 12.184 10.121 12.769 10.668C13.354 11.218 13.526 11.945 13.476 11.992C13.426 12.039 12.646 11.879 12.06 11.332C11.475 10.782 11.303 10.055 11.354 10.008ZM9.47504 10.008C9.42504 9.961 8.64504 10.121 8.06104 10.668C7.47604 11.218 7.30404 11.945 7.35504 11.992C7.40504 12.039 8.18304 11.879 8.76904 11.332C9.35504 10.782 9.52604 10.055 9.47604 10.008H9.47504Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 12C10.857 12 13 9.985 13 7.5C13 5.015 10.857 3 10.5 3C10.143 3 8 5.015 8 7.5C8 9.985 10.143 12 10.5 12Z"
                    fill="#BD0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.5 9C8.57 9 9 8.328 9 7.5C9 6.672 8.57 6 8.5 6C8.43 6 8 6.672 8 7.5C8 8.328 8.43 9 8.5 9ZM12.5 9C12.57 9 13 8.328 13 7.5C13 6.672 12.57 6 12.5 6C12.43 6 12 6.672 12 7.5C12 8.328 12.43 9 12.5 9Z"
                    fill="black"
                />
                <path
                    d="M11 7.5C11 6.67157 10.7761 6 10.5 6C10.2239 6 10 6.67157 10 7.5C10 8.32843 10.2239 9 10.5 9C10.7761 9 11 8.32843 11 7.5Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const KG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#EB0624"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.206 9.485C10.303 9.495 10.401 9.5 10.5 9.5C10.6 9.5 10.697 9.495 10.794 9.485L10.5 8.75L10.206 9.485ZM8.85 8.94C8.327 8.526 8 7.922 8 7.25C8 6.457 8.456 5.76 9.144 5.36L10 7.5L8.85 8.94ZM11.856 5.36C12.544 5.76 13 6.457 13 7.25C13 7.923 12.672 8.527 12.15 8.94L11 7.5L11.856 5.36ZM11.756 5.304C11.386 5.11 10.958 5 10.5 5C10.042 5 9.613 5.11 9.244 5.304L10.5 6.874L11.756 5.304Z"
                    fill="#FFF100"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 12C12.985 12 15 9.985 15 7.5C15 5.015 12.985 3 10.5 3C8.015 3 6 5.015 6 7.5C6 9.985 8.015 12 10.5 12ZM10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z"
                    fill="#FFF100"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const KH = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#E3001A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 5H8.5L9 6H8V5ZM9 6H10V7H9V6ZM8 7H9V8H8V7ZM7 8H8V9H7V8ZM7 9H8V10H7V9ZM6.5 9H7V10H6L6.5 9ZM9 8H11V10H9V8ZM13 5H12.5L12 6H13V5ZM12 6H11V7H12V6ZM13 7H12V8H13V7ZM14 8H13V9H14V8ZM14 9H13V10H14V9ZM14.5 9H14V10H15L14.5 9ZM12 8H11V10H12V8Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7H10V8H9V7ZM8 8H9V10H8V8ZM8 6H9V7H8V6ZM7.5 7H8V8H7L7.5 7ZM12 7H11V8H12V7ZM13 8H12V10H13V8ZM13 6H12V7H13V6ZM13.5 7H13V8H14L13.5 7ZM11 6H10V8H11V6Z"
                    fill="#F5DDE0"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 5H11V6H10V5Z"
                    fill="#B4B4B4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V4H0V0ZM0 11H21V15H0V11Z"
                    fill="#0028A4"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const KI = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    d="M10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V15H0V8Z"
                    fill="#003D89"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V9H0V8ZM0 10H21V11H0V10ZM0 12H21V13H0V12Z"
                    fill="white"
                />
            </g>
            <mask
                id="mask1"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask1)">
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 2L10.5 3L13 2H8Z"
                    fill="#FDD200"
                />
            </g>
        </svg>
    )
}

export const KM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#E3001A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V4H0V0Z"
                    fill="#FFC700"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4H21V8H0V4Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#3673C7"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L12 7.5L0 15V0Z"
                    fill="#398F2D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 10.84C5.71 10.944 5.4 11 5.077 11C3.377 11 2 9.433 2 7.5C2 5.567 3.378 4 5.077 4C5.399 4 5.709 4.056 6 4.16C4.752 4.606 3.846 5.933 3.846 7.5C3.846 9.067 4.752 10.394 6 10.84ZM6 5H7V6H6V5ZM6 7H7V8H6V7ZM6 9H7V10H6V9Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const KP = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#004DA4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 3H21V4H0V3Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4H21V11H0V4Z"
                    fill="#F0161B"
                />
                <path
                    d="M5.5 10C6.88071 10 8 8.88071 8 7.5C8 6.11929 6.88071 5 5.5 5C4.11929 5 3 6.11929 3 7.5C3 8.88071 4.11929 10 5.5 10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.49798 8.47603L4.29798 9.10603L4.52798 7.77103L3.55798 6.82703L4.89798 6.63203L5.49798 5.41803L6.09798 6.63303L7.43798 6.82903L6.46798 7.77403L6.69798 9.11003"
                    fill="#F0161B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V12H0V11Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const KR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 7.5C14 9.433 12.433 11 10.5 11C8.567 11 7 9.433 7 7.5C7 6.38 9.35 5.91 11.328 6.087C11.538 6.031 11.764 6 12 6C13.105 6 14 6.672 14 7.5Z"
                    fill="#0048AB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 7C10 7 10.895 6 12 6C13.105 6 14 6.672 14 7.5C14 5.567 12.433 4 10.5 4C9.103 4 7.897 4.818 7.336 6.002C7 7 7 7.292 7 7.5C7.5 8 8.056 8 8.5 8C8.944 8 9.343 7.807 9.618 7.5L10 7Z"
                    fill="#CD0027"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 5H17L15 3H14L15 5ZM6 5H4L6 3H7L6 5ZM15 10H17L15 12H14L15 10ZM6 10H4L6 12H7L6 10Z"
                    fill="#252526"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const KW = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#007B3A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15.033V0L7 5V10L0 15.033Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const KZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00AFCC"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 2.495C2 2.222 2.232 2 2.5 2C2.776 2 3 2.216 3 2.495V4.505C3 4.778 2.768 5 2.5 5C2.224 5 2 4.784 2 4.505V2.495ZM3 4.495C3 4.222 3.232 4 3.5 4C3.776 4 4 4.216 4 4.495V6.505C4 6.778 3.768 7 3.5 7C3.224 7 3 6.784 3 6.505V4.495ZM3 8.495C3 8.222 3.232 8 3.5 8C3.776 8 4 8.216 4 8.495V10.505C4 10.778 3.768 11 3.5 11C3.224 11 3 10.784 3 10.505V8.495ZM2 10.495C2 10.222 2.232 10 2.5 10C2.776 10 3 10.216 3 10.495V12.505C3 12.778 2.768 13 2.5 13C2.224 13 2 12.784 2 12.505V10.495ZM2 6.5C2 6.224 2.232 6 2.5 6C2.776 6 3 6.232 3 6.5C3 6.776 2.768 7 2.5 7C2.224 7 2 6.768 2 6.5ZM3 2.5C3 2.224 3.232 2 3.5 2C3.776 2 4 2.232 4 2.5C4 2.776 3.768 3 3.5 3C3.224 3 3 2.768 3 2.5ZM2 7.5C2 7.224 2.232 7 2.5 7C2.776 7 3 7.232 3 7.5C3 7.776 2.768 8 2.5 8C2.224 8 2 7.768 2 7.5ZM3 12.5C3 12.224 3.232 12 3.5 12C3.776 12 4 12.232 4 12.5C4 12.776 3.768 13 3.5 13C3.224 13 3 12.768 3 12.5ZM2 8.5C2 8.224 2.232 8 2.5 8C2.776 8 3 8.232 3 8.5C3 8.776 2.768 9 2.5 9C2.224 9 2 8.768 2 8.5Z"
                    fill="#DAC21D"
                />
                <path
                    d="M11.5 9C12.8807 9 14 7.88071 14 6.5C14 5.11929 12.8807 4 11.5 4C10.1193 4 9 5.11929 9 6.5C9 7.88071 10.1193 9 11.5 9Z"
                    fill="#FFC600"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 7L9 9L11.5 10L14 9L15 7V10L11.5 11L8 10V7Z"
                    fill="#FFC600"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00256A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 10C11.88 10 13 8.88 13 7.5C13 6.12 11.88 5 10.5 5C9.12 5 8 6.12 8 7.5C8 8.88 9.12 10 10.5 10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11ZM0 0H21V4H0V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LB = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11ZM0 0H21V4H0V0Z"
                    fill="#F01616"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 4L7 10H9L10.5 11L12 10H14L10.5 4Z"
                    fill="#00A74D"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LC = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#72D2FF"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 13L10.5 2L15 13H6Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 13L10.5 4L14 13H7Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 13L10.5 8L15 13H6Z"
                    fill="#FCD715"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LI = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V7H0V0Z"
                    fill="#002781"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 5H8V6H4V5Z"
                    fill="#947F1E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.01 3.142C4.702 3.062 4.35 3 4 3C3 3 3 3.5 3 4C3 4.5 4 5 4 5H8C8 5 9 4.5 9 4C9 3.5 9 3 8 3C7.65 3 7.298 3.062 6.99 3.142C6.997 3.095 7 3.048 7 3C7 2.448 6.552 2 6 2C5.448 2 5 2.448 5 3C5 3.048 5.003 3.095 5.01 3.142Z"
                    fill="#FFD923"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LK = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFBF00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 2H5V13H2V2Z"
                    fill="#00614A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 2H8V13H5V2Z"
                    fill="#FF6600"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 2H19V13H9V2Z"
                    fill="#98232E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.535 10.616L12.593 10.572L12.617 10.616C12.65 10.676 12.741 10.674 12.801 10.616L12.848 10.569L12.888 10.614C12.938 10.674 13.032 10.674 13.092 10.614C13.136 10.572 13.142 10.571 13.17 10.604C13.186 10.622 13.235 10.644 13.278 10.651C13.356 10.665 13.358 10.664 13.403 10.573C13.443 10.497 13.448 10.467 13.439 10.393C13.433 10.343 13.426 10.265 13.424 10.218C13.422 10.132 13.422 10.131 13.516 10.088C13.566 10.064 13.626 10.032 13.649 10.016C13.686 9.98999 13.789 9.82899 13.789 9.79599C13.789 9.78799 13.749 9.77599 13.699 9.76799C13.504 9.73799 13.471 9.59799 13.599 9.33799C13.806 8.91599 13.931 8.50299 13.932 8.23999C13.932 8.12299 13.937 8.08299 13.949 8.10999C13.995 8.21299 13.912 8.64999 13.786 8.96499L13.736 9.09199L13.784 9.07699C13.81 9.06699 13.967 8.97999 14.131 8.88099C14.581 8.61099 14.736 8.55699 15.028 8.57299C15.272 8.58699 15.376 8.64999 15.548 8.89099C15.64 9.01799 15.728 9.10899 15.888 9.24299C16.232 9.52899 16.246 9.55299 16.262 9.88899C16.279 10.229 16.272 10.249 16.077 10.305C15.912 10.353 15.807 10.455 15.78 10.598C15.766 10.675 15.797 10.678 15.88 10.606L15.94 10.554L15.968 10.606C16.004 10.676 16.08 10.676 16.143 10.606L16.19 10.556L16.238 10.606C16.314 10.686 16.415 10.668 16.443 10.566C16.448 10.548 16.463 10.554 16.493 10.588C16.548 10.652 16.689 10.68 16.705 10.628C16.711 10.61 16.699 10.563 16.68 10.524C16.598 10.36 16.572 10.281 16.57 10.192C16.57 10.068 16.597 10.008 16.704 9.90599C16.834 9.78299 16.874 9.62599 16.776 9.62599C16.716 9.62599 16.654 9.55299 16.616 9.43599C16.536 9.20099 16.551 8.93599 16.67 8.49599C16.79 8.04599 16.804 7.96599 16.805 7.66599C16.805 7.42299 16.802 7.38099 16.76 7.24799C16.735 7.16799 16.683 7.04599 16.646 6.97999L16.579 6.85999L16.666 6.76199C16.933 6.46799 16.879 5.98599 16.556 5.80199C16.459 5.74399 16.434 5.73899 16.262 5.74199C16.158 5.74199 16.002 5.75999 15.912 5.78199C15.82 5.80199 15.666 5.81999 15.56 5.81999C15.392 5.81999 15.364 5.81599 15.3 5.76999C15.232 5.72199 15.22 5.69999 15.207 5.58999C15.205 5.56599 15.193 5.54399 15.181 5.53999C15.158 5.52999 15.051 5.64999 15.037 5.70599C15.029 5.73199 15.022 5.72999 15 5.69599C14.985 5.67099 14.964 5.61599 14.953 5.57399C14.926 5.46599 14.959 5.38399 15.053 5.32399L15.128 5.27799L15.086 5.24199C14.996 5.16799 14.843 5.21799 14.788 5.34199C14.772 5.37499 14.755 5.40399 14.75 5.40399C14.745 5.40399 14.715 5.37099 14.684 5.33099C14.568 5.18099 14.608 4.95699 14.764 4.88799C14.846 4.85199 14.919 4.87999 14.934 4.95299C14.957 5.06499 15.03 4.91799 15.017 4.78499C15.007 4.69699 15.007 4.69299 15.054 4.69299C15.118 4.69299 15.254 4.80499 15.297 4.89299C15.347 4.99299 15.342 5.15299 15.287 5.27099L15.247 5.36399L15.301 5.34999C15.381 5.32799 15.461 5.25999 15.501 5.17999C15.543 5.09399 15.548 4.92699 15.511 4.83599C15.474 4.74899 15.478 4.73599 15.531 4.76599C15.623 4.81599 15.671 4.86999 15.708 4.96599C15.742 5.05099 15.744 5.07199 15.726 5.16099C15.716 5.21599 15.691 5.28799 15.672 5.32099C15.642 5.37399 15.642 5.38299 15.665 5.38299C15.708 5.38299 15.8 5.32799 15.832 5.28299C15.848 5.25899 15.872 5.20299 15.885 5.15499L15.908 5.07099L15.935 5.13499C15.973 5.22499 16.045 5.30799 16.135 5.35899C16.232 5.41499 16.272 5.41899 16.222 5.36699C16.188 5.33199 16.125 5.08699 16.144 5.06399C16.154 5.04999 16.286 5.18399 16.434 5.36199C16.576 5.53199 16.664 5.58599 16.794 5.58599C16.961 5.58599 17.057 5.39399 16.984 5.21299C16.939 5.10699 16.842 5.09299 16.786 5.18299C16.76 5.22499 16.753 5.25799 16.76 5.30099C16.77 5.35499 16.766 5.36099 16.73 5.36099C16.68 5.36099 16.586 5.28099 16.418 5.09299C16.161 4.80799 15.848 4.56599 15.623 4.47799C15.478 4.41999 15.169 4.39799 15.023 4.43399C14.863 4.47199 14.673 4.59399 14.571 4.72399C14.389 4.95399 14.387 5.25899 14.564 5.53799L14.614 5.61799L14.58 5.68799C14.53 5.79199 14.534 5.93099 14.59 6.03299C14.615 6.07799 14.64 6.11499 14.646 6.11499C14.652 6.11499 14.658 6.08499 14.66 6.04999C14.665 5.95999 14.694 5.89999 14.744 5.87699C14.788 5.85499 14.817 5.86499 15.022 5.97299C15.237 6.08799 15.59 6.09499 15.966 5.99299C16.151 5.94499 16.368 5.94799 16.464 6.00099C16.639 6.09899 16.68 6.35299 16.551 6.54599C16.495 6.62799 16.441 6.66199 16.261 6.72799C16.123 6.77799 16.091 6.78199 15.778 6.77799C15.511 6.77399 15.415 6.78099 15.306 6.81099C15.188 6.84399 15.116 6.84699 14.768 6.83599L14.366 6.82199L14.411 6.87199C14.435 6.89799 14.471 6.93199 14.488 6.94499C14.518 6.96699 14.518 6.96999 14.472 6.99199C14.445 7.00599 14.387 7.01599 14.342 7.01599H14.259L14.249 7.10999C14.243 7.16199 14.243 7.21999 14.249 7.24299C14.259 7.27599 14.256 7.27999 14.229 7.26799C14.213 7.25799 14.165 7.24299 14.123 7.23099C14.081 7.21899 14.025 7.19599 13.998 7.17799C13.952 7.14799 13.948 7.14799 13.93 7.18799C13.916 7.22399 13.776 7.36199 13.755 7.36199C13.752 7.36199 13.748 7.33499 13.745 7.30199C13.745 7.26999 13.725 7.18499 13.701 7.11399C13.679 7.04399 13.655 6.96599 13.649 6.94199C13.639 6.90599 13.636 6.90399 13.624 6.93199C13.617 6.94899 13.606 6.99699 13.6 7.03899C13.595 7.07899 13.574 7.14899 13.554 7.18899L13.518 7.26299L13.495 7.19899C13.471 7.13099 13.43 7.05899 13.415 7.05899C13.41 7.05899 13.401 7.08199 13.395 7.10899C13.385 7.16399 13.288 7.31899 13.265 7.31899C13.255 7.31899 13.248 7.27499 13.248 7.22199C13.248 7.16799 13.241 7.12499 13.231 7.12499C13.223 7.12499 13.215 7.13799 13.215 7.15499C13.215 7.19499 13.132 7.31799 13.105 7.31799C13.092 7.31799 13.073 7.33199 13.061 7.34999C13.031 7.39599 13.006 7.38999 13.018 7.33999C13.025 7.31499 13.021 7.25999 13.01 7.21499L12.983 7.10999C12.979 7.09399 12.95 7.09799 12.887 7.12499C12.785 7.16799 12.751 7.16099 12.803 7.10499C12.823 7.08499 12.853 7.01699 12.868 6.95299C12.884 6.88899 12.908 6.83299 12.922 6.82599C12.94 6.81999 12.939 6.82899 12.917 6.86799C12.902 6.89599 12.889 6.93399 12.889 6.95199C12.889 6.96999 12.876 7.01199 12.862 7.04699C12.848 7.08299 12.839 7.11399 12.842 7.11699C12.846 7.12199 12.884 7.10299 12.928 7.07499L13.008 7.02499V7.06999C13.008 7.09499 13.018 7.15999 13.028 7.21599L13.05 7.31599L13.104 7.28299C13.159 7.24899 13.212 7.12799 13.212 7.03499C13.212 6.98699 13.232 6.99499 13.24 7.04499L13.268 7.16499L13.292 7.25899L13.329 7.19899C13.349 7.16599 13.376 7.10199 13.387 7.05599C13.407 6.97799 13.435 6.94399 13.435 7.00099C13.435 7.04299 13.521 7.19099 13.537 7.17899C13.545 7.17299 13.561 7.11699 13.572 7.05499C13.596 6.92499 13.634 6.83699 13.659 6.85499C13.669 6.86299 13.671 6.87499 13.666 6.88499C13.662 6.89499 13.681 6.97999 13.71 7.07299C13.74 7.16599 13.77 7.25999 13.775 7.28099C13.785 7.31599 13.795 7.31099 13.857 7.23799C13.897 7.19299 13.931 7.14299 13.935 7.12599C13.941 7.10199 13.95 7.10299 13.985 7.13199C14.035 7.17399 14.205 7.24199 14.218 7.22399C14.223 7.21799 14.228 7.15899 14.228 7.09399L14.231 6.97399L14.281 6.98699C14.308 6.99499 14.364 6.99399 14.406 6.98699L14.482 6.97199L14.415 6.90999C14.378 6.87599 14.34 6.83199 14.331 6.81199C14.321 6.79199 14.287 6.77199 14.251 6.76899C14.148 6.75699 13.967 6.62199 13.967 6.55899C13.967 6.54599 13.992 6.56599 14.023 6.60399C14.091 6.68599 14.185 6.73799 14.267 6.73799H14.329L14.291 6.67199C14.269 6.63199 14.249 6.55999 14.244 6.49899C14.237 6.40399 14.229 6.38899 14.154 6.31899C14.109 6.27699 14.052 6.21399 14.029 6.17899L13.987 6.11599L13.965 6.19099C13.953 6.23299 13.938 6.26599 13.933 6.26599C13.927 6.26599 13.903 6.24199 13.883 6.21299C13.86 6.18299 13.837 6.15899 13.833 6.15899C13.826 6.15899 13.807 6.19899 13.788 6.24899L13.755 6.33599L13.729 6.28599C13.714 6.25599 13.681 6.20799 13.654 6.17599C13.627 6.14199 13.612 6.11599 13.622 6.11599C13.632 6.11599 13.666 6.14999 13.697 6.19099L13.754 6.26699L13.777 6.21099C13.79 6.17899 13.795 6.12799 13.789 6.08699C13.779 6.02699 13.781 6.02499 13.799 6.06199C13.809 6.08599 13.842 6.13199 13.872 6.16199L13.926 6.22199L13.963 6.13199C14 6.04199 14.001 6.04199 14.017 6.09399C14.04 6.16599 14.202 6.34399 14.34 6.44599C14.36 6.46199 14.352 6.40599 14.313 6.28099C14.303 6.24799 14.293 6.18799 14.293 6.14799C14.293 6.08799 14.281 6.06099 14.223 6.00299C14.141 5.91899 14.115 5.85999 14.099 5.72499C14.093 5.66999 14.079 5.60899 14.067 5.58999C14.05 5.55999 14.047 5.57699 14.052 5.67799C14.054 5.74799 14.047 5.83199 14.036 5.86799L14.016 5.93199L14 5.87799C13.99 5.84799 13.953 5.79799 13.915 5.76299C13.875 5.72999 13.85 5.69699 13.855 5.68999C13.86 5.68399 13.9 5.71399 13.942 5.75799C14.007 5.82499 14.022 5.83199 14.03 5.80299C14.04 5.76799 14.03 5.61699 14.01 5.51299C14 5.45899 14 5.45899 14.05 5.52299C14.086 5.57299 14.105 5.62899 14.12 5.72899C14.14 5.85599 14.15 5.87899 14.238 5.97899C14.291 6.04199 14.338 6.08899 14.34 6.08499C14.344 6.08099 14.35 5.92099 14.355 5.72999C14.365 5.36499 14.355 5.27799 14.288 5.16499L14.254 5.10699L14.307 5.02999C14.377 4.92999 14.409 4.84999 14.423 4.73999L14.435 4.64999L14.375 4.72699C14.325 4.78899 14.302 4.80299 14.245 4.80299C14.188 4.80299 14.165 4.79099 14.128 4.73599C14.082 4.67099 14 4.60899 13.922 4.57799C13.892 4.56799 13.882 4.57199 13.882 4.59799C13.882 4.61799 13.867 4.67199 13.847 4.71999L13.812 4.80799L13.738 4.70999C13.692 4.64999 13.638 4.60399 13.598 4.58999C13.495 4.55399 13.49 4.55699 13.49 4.65999C13.49 4.81299 13.44 4.84199 13.35 4.73999C13.283 4.65999 13.226 4.64399 13.097 4.66299L12.997 4.67799L13.017 4.73799C13.031 4.78799 13.027 4.80799 12.995 4.86499C12.943 4.95699 12.875 4.99699 12.771 4.99699C12.723 4.99699 12.663 5.00999 12.637 5.02699C12.612 5.04199 12.549 5.06099 12.497 5.06699C12.445 5.07399 12.39 5.08699 12.374 5.09399C12.35 5.10599 12.347 5.09599 12.354 5.02199C12.367 4.90799 12.308 4.82499 12.214 4.82499C12.094 4.82499 12.039 4.96799 12.086 5.15699C12.096 5.19299 12.106 5.25099 12.112 5.28399C12.119 5.31899 12.172 5.41199 12.24 5.50099C12.304 5.58699 12.364 5.67599 12.374 5.69899C12.384 5.72199 12.417 5.75899 12.447 5.78099L12.502 5.82099L12.495 5.74399C12.487 5.65799 12.501 5.64399 12.535 5.70399C12.548 5.72699 12.579 5.76199 12.605 5.78399C12.645 5.81599 12.652 5.81699 12.652 5.78799C12.652 5.76799 12.66 5.72799 12.67 5.69399L12.69 5.63399L12.72 5.71599C12.738 5.76099 12.796 5.86399 12.848 5.94599C12.95 6.10099 13.012 6.27599 12.98 6.31599C12.967 6.33299 12.932 6.33099 12.86 6.31199C12.803 6.29799 12.733 6.28999 12.704 6.29499C12.644 6.30499 12.641 6.29499 12.677 6.23499C12.715 6.17199 12.709 6.16199 12.634 6.16199C12.547 6.16199 12.332 6.10599 12.249 6.06199C12.169 6.02199 12.149 6.03199 12.126 6.13199L12.083 6.31699L12.06 6.41699L12.147 6.40699C12.195 6.39999 12.257 6.38699 12.284 6.37499C12.312 6.36499 12.337 6.35899 12.34 6.36199C12.343 6.36599 12.33 6.40599 12.313 6.44999L12.279 6.52999L12.334 6.51599C12.364 6.50799 12.409 6.48799 12.434 6.47199C12.478 6.44399 12.481 6.44599 12.516 6.51899C12.558 6.60899 12.592 6.60599 12.599 6.50899C12.607 6.41099 12.632 6.42599 12.679 6.55699C12.722 6.68299 12.769 6.72699 12.777 6.65299C12.78 6.62899 12.803 6.58799 12.83 6.56299C12.883 6.51299 12.923 6.52899 12.945 6.60699C12.97 6.68699 12.917 6.77099 12.765 6.89499C12.455 7.14299 12.277 7.48299 12.225 7.91499C12.179 8.30499 12.323 8.70899 12.612 8.99899C12.75 9.13899 12.97 9.28399 12.956 9.22899C12.898 8.99099 12.9 8.53899 12.96 8.46199C12.97 8.44999 12.966 8.49699 12.953 8.56599C12.905 8.82399 12.926 9.02899 13.05 9.50999C13.16 9.94599 13.146 10.132 12.988 10.254C12.938 10.294 12.904 10.3 12.768 10.298C12.62 10.296 12.604 10.3 12.556 10.35C12.51 10.4 12.451 10.56 12.451 10.634C12.451 10.674 12.484 10.669 12.551 10.618L12.535 10.616ZM11.415 9.81599C11.431 9.78899 11.443 9.74599 11.443 9.72099C11.443 9.68299 11.456 9.67299 11.52 9.66099L11.597 9.64699L11.547 9.59199C11.485 9.52799 11.479 9.47799 11.533 9.47799C11.586 9.47799 11.677 9.40399 11.691 9.34799C11.698 9.32399 11.694 9.28999 11.683 9.27199C11.653 9.22699 11.596 9.23399 11.586 9.28399C11.574 9.33799 11.556 9.33899 11.513 9.28399C11.449 9.20399 11.447 9.03599 11.51 8.93799C11.538 8.89199 11.538 8.88799 11.5 8.84199C11.46 8.78999 11.43 8.68899 11.45 8.66499C11.456 8.65799 11.488 8.66499 11.52 8.67899C11.568 8.69899 11.587 8.70099 11.606 8.67899C11.666 8.61899 11.601 8.53899 11.506 8.55699C11.469 8.56399 11.454 8.55699 11.448 8.53099C11.444 8.51099 11.411 8.48399 11.373 8.47099C11.307 8.44899 11.306 8.45099 11.306 8.51099C11.306 8.57799 11.276 8.59099 11.223 8.54799C11.178 8.51299 11.135 8.53999 11.135 8.60299C11.135 8.66099 11.18 8.68999 11.259 8.68299C11.319 8.67799 11.322 8.73899 11.264 8.82499L11.222 8.88799L11.255 8.95099C11.305 9.04399 11.3 9.19899 11.245 9.27599L11.205 9.33599L11.177 9.28799C11.139 9.22099 11.087 9.22599 11.072 9.29799C11.062 9.34499 11.072 9.36599 11.115 9.41599C11.145 9.44899 11.188 9.47599 11.211 9.47599C11.269 9.47599 11.267 9.53599 11.207 9.59799L11.16 9.64599L11.234 9.66099C11.274 9.66899 11.306 9.68499 11.306 9.69599C11.306 9.73599 11.356 9.86399 11.373 9.86399C11.383 9.86399 11.403 9.84399 11.416 9.81699L11.415 9.81599ZM11.668 7.64599C11.834 7.54899 11.848 7.30199 11.692 7.23599C11.627 7.20999 11.586 7.22599 11.562 7.28299C11.542 7.32799 11.555 7.40899 11.582 7.40899C11.59 7.40899 11.597 7.42299 11.597 7.44099C11.597 7.52699 11.344 7.56599 11.241 7.49599C11.205 7.47099 11.191 7.40799 11.221 7.40799C11.241 7.40799 11.258 7.34199 11.247 7.29599C11.231 7.23399 11.183 7.21199 11.115 7.23599C10.96 7.28999 10.965 7.53199 11.122 7.63599C11.252 7.71899 11.536 7.72399 11.67 7.64599H11.668ZM11.565 7.45599C11.575 7.44599 11.571 7.42599 11.555 7.40899C11.52 7.37199 11.522 7.31699 11.56 7.25399C11.59 7.20699 11.593 7.13699 11.603 6.42799C11.62 5.20399 11.688 4.28499 11.778 4.06499C11.814 3.97699 11.808 3.97499 11.716 4.05999C11.596 4.16799 11.506 4.30999 11.426 4.50999C11.274 4.88999 11.221 5.40199 11.221 6.49399C11.221 7.11399 11.225 7.19399 11.251 7.25399C11.277 7.30799 11.278 7.32899 11.261 7.38799C11.249 7.42599 11.244 7.46299 11.249 7.46799C11.283 7.51199 11.529 7.50099 11.566 7.45499L11.565 7.45599Z"
                    fill="#FFB700"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 3H11V4H10V3ZM17 3H18V4H17V3ZM10 11H11V12H10V11ZM17 11H18V12H17V11Z"
                    fill="#DA8210"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 0H21V1H7V0ZM7 2H21V3H7V2ZM7 4H21V5H7V4ZM7 6H21V7H7V6ZM0 8H21V9H0V8ZM0 10H21V11H0V10ZM0 12H21V13H0V12Z"
                    fill="#C1012B"
                />
                <path d="M21 14H0V15H21V14Z" fill="#C1012B" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V7H0V0Z"
                    fill="#00256A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.44 4.89699L1.932 5.68999L2.22 4.00999L1 2.82299L2.686 2.57799L3.44 1.04999L4.194 2.57699L5.88 2.82199L4.66 4.01199L4.948 5.68999"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LS = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.1 5.8L9 8H12L10.9 5.8C10.963 5.716 11 5.613 11 5.5C11 5.224 10.776 5 10.5 5C10.224 5 10 5.224 10 5.5C10 5.613 10.037 5.716 10.1 5.8ZM13 9C13 9.552 11.88 10 10.5 10C9.12 10 8 9.552 8 9V8H13V9Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#00963F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V4H0V0Z"
                    fill="#0017A2"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LT = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#006B43"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#C32427"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#FFBA00"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LU = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#00A0E1"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#F02532"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LV = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 9H21V15H0V9ZM0 0H21V6H0V0Z"
                    fill="#A02F37"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const LY = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#179F41"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V4H0V0Z"
                    fill="#EA0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7H13V8H12V7Z"
                    fill="#FBDCE2"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 9C12.044 9.607 11.318 10 10.5 10C9.12 10 8 8.88 8 7.5C8 6.12 9.12 5 10.5 5C11.318 5 12.044 5.393 12.5 6H11C10.172 6 9.5 6.672 9.5 7.5C9.5 8.328 10.172 9 11 9H12.5Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#C32427"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.4999 8.99001L9.02995 9.76001L9.30995 8.12501L8.12195 6.96501L9.76495 6.72701L10.4999 5.23901L11.2349 6.72601L12.8779 6.96601L11.6879 8.12401L11.9679 9.76001"
                    fill="#006331"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MC = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V15H0V8Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MD = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFD300"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#0042B1"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 5H13V10H8V5ZM8 10L10.5 12L13 10H8ZM10 4H11V5H10V4Z"
                    fill="#B17F51"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6H12V8H9V6Z"
                    fill="#D30021"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 8H12V9.5H9V8ZM9 9.5L10.5 10.5L12 9.5H9Z"
                    fill="#0140BE"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 7C10.776 7 11 7.214 11 7.505V8.495C11 8.775 10.768 9 10.5 9C10.224 9 10 8.786 10 8.495V7.505C10 7.225 10.232 7 10.5 7Z"
                    fill="#FFD300"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#CE0029"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ME = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                fill="#D4AF2C"
            />
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="1"
                y="1"
                width="19"
                height="13"
            >
                <path
                    d="M19 1H2C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H19C19.5523 14 20 13.5523 20 13V2C20 1.44772 19.5523 1 19 1Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 1H2C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H19C19.5523 14 20 13.5523 20 13V2C20 1.44772 19.5523 1 19 1Z"
                    fill="#C60000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 4.778L9.333 4L8.556 4.778H9.333L8.556 5.556L7 4.778V8.668L9.333 7.888L8.556 9.444H7.778L8.556 10.222L9.333 9.444L10.5 11V4.778ZM11.667 4L12.444 4.778H11.667L12.444 5.556L14 4.778V8.668L11.667 7.888L12.444 9.444H13.222L12.444 10.222L11.667 9.444L10.5 11V4.778L11.667 4Z"
                    fill="#D5B02B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6.505C9 5.675 9.666 5 10.5 5C11.328 5 12 5.673 12 6.505V6.162C12 6.992 11.492 8.118 10.88 8.664L10.5 9L10.12 8.664C9.503 8.114 9 6.994 9 6.162V6.505Z"
                    fill="#185D93"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 6H12V7H9V6Z"
                    fill="#C58724"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FF3A27"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H21V15H0V8Z"
                    fill="#007F37"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H8V15H0V0Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MH = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#003495"
                />
                <path
                    d="M5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L21 6V3L0 15Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L21 0V3L0 15Z"
                    fill="#DF7500"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MK = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D40000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L10 7H11L4 0H0ZM0 15L10 8H11L4 15H0Z"
                    fill="#FFE800"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 7H10L17 0H21L11 7ZM11 8H10L17 15H21L11 8ZM8 7L0 6V9L8 8V7ZM13 7L21 6V9L13 8V7ZM10 5L9 0H12L11 5H10ZM10 10L9 15H12L11 10"
                    fill="#FFE800"
                />
                <path
                    d="M10.5 10C11.8807 10 13 8.88071 13 7.5C13 6.11929 11.8807 5 10.5 5C9.11929 5 8 6.11929 8 7.5C8 8.88071 9.11929 10 10.5 10Z"
                    fill="#D40000"
                />
                <path
                    d="M10.5 9C11.3284 9 12 8.32843 12 7.5C12 6.67157 11.3284 6 10.5 6C9.67157 6 9 6.67157 9 7.5C9 8.32843 9.67157 9 10.5 9Z"
                    fill="#FFE800"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ML = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#00B731"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#2BB428"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#ED2432"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#FFCC00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 9.75L7.85497 11.14L8.35997 8.195L6.21997 6.11L9.17697 5.68L10.5 3L11.823 5.68L14.78 6.11L12.64 8.195L13.145 11.141"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#004F99"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#C62429"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 7H3V11H2V7ZM5 7H6V11H5V7Z"
                    fill="#FAD000"
                />
                <path
                    d="M4 11C4.55228 11 5 10.5523 5 10C5 9.44772 4.55228 9 4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11Z"
                    fill="#FAD000"
                />
                <path
                    d="M4 8C4.55228 8 5 7.55228 5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8Z"
                    fill="#FAD000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 3L5 5H3L4 3Z"
                    fill="#FAD000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#C62429"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#006331"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.498 7.24999L9.028 8.02299L9.30799 6.38599L8.12 5.22599L9.76299 4.98899L10.498 3.49899L11.232 4.98899L12.875 5.22599L11.685 6.38599L11.967 8.02199"
                    fill="#FFC500"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.965 5.93801C14.988 6.12201 15 6.31001 15 6.50001C15 8.98501 12.985 11 10.5 11C8.015 11 6 8.98501 6 6.50001C6 6.31001 6.012 6.12201 6.035 5.93701C6.312 7.66501 8.205 9.00001 10.5 9.00001C12.795 9.00001 14.688 7.66401 14.965 5.93701V5.93801Z"
                    fill="#FFC500"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MT = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D10D24"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H11V15H0V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 3H2V4H3V5H4V4H5V3H4V2H3V3Z"
                    fill="#CCCCCC"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MU = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFD700"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#2C9F2D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4H21V8H0V4Z"
                    fill="#191D6F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V4H0V0Z"
                    fill="#ED2432"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MV = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D4062E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 4H17V11H4V4Z"
                    fill="#007F37"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.125 9.92C10.925 9.973 10.715 10 10.5 10C9.12 10 8 8.88 8 7.5C8 6.12 9.12 5 10.5 5C10.716 5 10.925 5.027 11.125 5.08C10.478 5.355 10 6.334 10 7.5C10 8.666 10.478 9.644 11.125 9.92Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MW = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#2C9F2D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.242 4C13.435 2.794 12.06 2 10.5 2C8.94 2 7.565 2.794 6.758 4H14.242Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MX = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 7.5C13 6.12 11.88 5 10.5 5C9.12 5 8 6.12 8 7.5C8 8.88 9.12 10 10.5 10C11.88 10 13 8.88 13 7.5ZM10.5 9C11.328 9 12 8.105 12 7C12 5.895 11.328 5 10.5 5C9.672 5 9 5.895 9 7C9 8.105 9.672 9 10.5 9Z"
                    fill="#406421"
                />
                <path
                    d="M10.5 8C10.7761 8 11 7.55228 11 7C11 6.44772 10.7761 6 10.5 6C10.2239 6 10 6.44772 10 7C10 7.55228 10.2239 8 10.5 8Z"
                    fill="#D5B852"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#006946"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MY = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 0H21V1H7V0ZM7 2H21V3H7V2ZM7 4H21V5H7V4ZM7 6H21V7H7V6ZM0 8H21V9H0V8ZM0 10H21V11H0V10ZM0 12H21V13H0V12Z"
                    fill="#CE0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H11V9H0V0Z"
                    fill="#000068"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 4H8V5H7V4Z"
                    fill="#FFCD00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.5 6C7.044 6.607 6.318 7 5.5 7C4.12 7 3 5.88 3 4.5C3 3.12 4.12 2 5.5 2C6.318 2 7.044 2.393 7.5 3H6C5.172 3 4.5 3.672 4.5 4.5C4.5 5.328 5.172 6 6 6H7.5Z"
                    fill="#FFCD00"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const MZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#FDE300"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#007168"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4H21V5H0V4ZM0 10H21V11H0V10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V15.033L10 7.5L0 0Z"
                    fill="#D4062E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.378 8.75L1.908 9.523L2.188 7.886L1 6.726L2.643 6.489L3.378 5L4.112 6.49L5.755 6.727L4.565 7.887L4.847 9.523"
                    fill="#FDE300"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.28003 6.384L2.63403 6.03L4.75403 8.152L4.40203 8.505L2.28003 6.385V6.384Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.75503 6.384L4.40203 6.03L2.28003 8.152L2.63403 8.505L4.75403 6.385L4.75503 6.384Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const NA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#003282"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15H21V2L0 13V15Z"
                    fill="#00963F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.498 5.23L3.028 6.003L3.308 4.366L2.12 3.206L3.763 2.969L4.498 1.479L5.232 2.969L6.875 3.206L5.685 4.366L5.967 6.002"
                    fill="#FFE000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 14L21 3V-1L0 10V14Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 16L21 5V1L0 12V16Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L21 4V0L0 11V15Z"
                    fill="#D4062E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const NE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#00B21D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#E25100"
                />
                <path
                    d="M10.5 9C11.3284 9 12 8.32843 12 7.5C12 6.67157 11.3284 6 10.5 6C9.67157 6 9 6.67157 9 7.5C9 8.32843 9.67157 9 10.5 9Z"
                    fill="#E25100"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const NG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0ZM14 0H21V15H14V0Z"
                    fill="#00884F"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const NI = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10ZM0 0H21V5H0V0Z"
                    fill="#0064C9"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 9L10.5 6L12 9H9Z"
                    fill="#C1DD1E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const NL = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#1E448D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#B01923"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const NO = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#F22722"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 9H0V6H6V0H9V6H21V9H9V15H6V9Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 8H0V7H7V0H8V7H21V8H8V15H7V8Z"
                    fill="#00256A"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const NP = () => {
    return (
        <svg
            width="13"
            height="15"
            viewBox="0 0 13 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0)">
                <mask
                    id="mask0"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="21"
                    height="15"
                >
                    <path
                        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0L13 8H6L13 15H0V0Z"
                        fill="#003495"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1 2L9 7H3L10 14H1.998C1.448 14 1 13.544 1 12.998V2Z"
                        fill="#DF0A37"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.915 5C4.97 5.078 5 5.162 5 5.25C5 5.664 4.328 6 3.5 6C2.672 6 2 5.664 2 5.25C2 5.162 2.03 5.078 2.085 5C2.291 5.146 2.847 5.25 3.5 5.25C4.153 5.25 4.71 5.146 4.915 5Z"
                        fill="white"
                    />
                    <path
                        d="M3.5 13C4.32843 13 5 12.3284 5 11.5C5 10.6716 4.32843 10 3.5 10C2.67157 10 2 10.6716 2 11.5C2 12.3284 2.67157 13 3.5 13Z"
                        fill="white"
                    />
                    <path
                        d="M1.762 1.303C1.065 0.859997 0.5 1.175 0.5 1.998V13.002C0.5 13.829 1.168 14.5 2.003 14.5H12L5 7.5H11.5L1.762 1.303Z"
                        stroke="black"
                        strokeOpacity="0.1"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="13" height="15" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const NR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#002781"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 7H21V8H0V7Z"
                    fill="#FFC700"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.498 12.23L6.028 13.003L6.308 11.366L5.12 10.206L6.763 9.969L7.498 8.479L8.232 9.969L9.875 10.206L8.685 11.366L8.967 13.002"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const NZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00008E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 4V5H16V4H15ZM17 6V7H18V6H17ZM13 7V8H14V7H13ZM15 11V12H16V11H15Z"
                    fill="#FF7F7F"
                />
                <path
                    d="M9 1H2C1.44772 1 1 1.44772 1 2V7C1 7.55228 1.44772 8 2 8H9C9.55229 8 10 7.55228 10 7V2C10 1.44772 9.55229 1 9 1Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 5H2V4H5V2H6V4H9V5H6V7H5V5ZM7.5 6V7H9V6H7.5ZM7.5 2V3H9V2H7.5ZM2 6V7H3.5V6H2ZM2 2V3H3.5V2H2Z"
                    fill="#FF0000"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const OM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#DE0F09"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 10H21V15H6V10Z"
                    fill="#008100"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.00002 0H21V5H6.00002V0ZM4.57602 3.903C4.52102 3.986 4.45802 4.063 4.38602 4.136C3.79902 4.722 2.84902 4.722 2.26402 4.136C1.67802 3.551 1.67802 2.601 2.26402 2.016C2.33602 1.942 2.41402 1.879 2.49702 1.824C2.27202 2.244 2.45702 2.916 2.97102 3.429C3.48502 3.941 4.15602 4.127 4.57702 3.902L4.57602 3.903Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.42397 3.90301C2.47897 3.98601 2.54197 4.06301 2.61397 4.13601C3.20097 4.72201 4.15097 4.72201 4.73597 4.13601C5.32197 3.55101 5.32197 2.60101 4.73597 2.01601C4.66397 1.94201 4.58597 1.87901 4.50297 1.82401C4.72797 2.24401 4.54297 2.91601 4.02897 3.42901C3.51497 3.941 2.84397 4.12701 2.42297 3.90201L2.42397 3.90301Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.974 4.974C5.908 5.57 5.72 6 5.5 6C5.28 6 5.092 5.57 5.026 4.974C4.43 4.908 4 4.72 4 4.5C4 4.28 4.43 4.092 5.026 4.026C5.092 3.43 5.28 3 5.5 3C5.72 3 5.908 3.43 5.974 4.026C6.57 4.092 7 4.28 7 4.5C7 4.72 6.57 4.908 5.974 4.974Z"
                    fill="#005095"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.974 11.974C15.908 12.57 15.72 13 15.5 13C15.28 13 15.092 12.57 15.026 11.974C14.43 11.908 14 11.72 14 11.5C14 11.28 14.43 11.092 15.026 11.026C15.092 10.43 15.279 10 15.5 10C15.72 10 15.908 10.43 15.974 11.026C16.57 11.092 17 11.279 17 11.5C17 11.72 16.57 11.908 15.974 11.974Z"
                    fill="#D4062E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 8H10V15H0V8Z"
                    fill="#005095"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 0H21V8H10V0Z"
                    fill="#D4062E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0ZM14 0H21V15H14V0Z"
                    fill="#DC0718"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 3L14 5C14 5 12 4 11 5L10 6H13L18 9L16 6H18C18 6 18 5 17 4C16 3 15 3 15 3V2L14 3H12Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L21 15H0V0Z"
                    fill="black"
                />
                <path
                    d="M5.5 8C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8Z"
                    fill="white"
                />
                <path
                    d="M3.5 10C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10Z"
                    fill="white"
                />
                <path
                    d="M7.5 10C7.77614 10 8 9.77614 8 9.5C8 9.22386 7.77614 9 7.5 9C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10Z"
                    fill="white"
                />
                <path
                    d="M5.5 13C5.77614 13 6 12.7761 6 12.5C6 12.2239 5.77614 12 5.5 12C5.22386 12 5 12.2239 5 12.5C5 12.7761 5.22386 13 5.5 13Z"
                    fill="white"
                />
                <path
                    d="M6.5 12C6.77614 12 7 11.7761 7 11.5C7 11.2239 6.77614 11 6.5 11C6.22386 11 6 11.2239 6 11.5C6 11.7761 6.22386 12 6.5 12Z"
                    fill="#C7C7C7"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PH = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D0091E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V8H0V0Z"
                    fill="#0033AB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V15.033L10 7.5L0 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.485 7.985C5.355 7.93 6 7.735 6 7.5C6 7.266 5.355 7.07 4.485 7.015C4.43 6.145 4.235 5.5 4 5.5C3.766 5.5 3.57 6.145 3.515 7.015C2.645 7.07 2 7.265 2 7.5C2 7.734 2.645 7.93 3.515 7.985C3.569 8.855 3.765 9.5 4 9.5C4.234 9.5 4.43 8.855 4.485 7.985Z"
                    fill="#FDD200"
                />
                <path
                    d="M7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8Z"
                    fill="#FDD200"
                />
                <path
                    d="M2.5 5C2.77614 5 3 4.77614 3 4.5C3 4.22386 2.77614 4 2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5Z"
                    fill="#FDD200"
                />
                <path
                    d="M2.5 11C2.77614 11 3 10.7761 3 10.5C3 10.2239 2.77614 10 2.5 10C2.22386 10 2 10.2239 2 10.5C2 10.7761 2.22386 11 2.5 11Z"
                    fill="#FDD200"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PK = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00421A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.974 5.974C15.908 6.57 15.72 7 15.5 7C15.28 7 15.092 6.57 15.026 5.974C14.43 5.908 14 5.72 14 5.5C14 5.28 14.43 5.092 15.026 5.026C15.092 4.43 15.28 4 15.5 4C15.72 4 15.908 4.43 15.974 5.026C16.57 5.092 17 5.28 17 5.5C17 5.72 16.57 5.908 15.974 5.974ZM0 0H6V15H0V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.97 6.968C17.99 7.143 18 7.32 18 7.5C18 9.985 15.985 12 13.5 12C11.015 12 9 9.985 9 7.5C9 5.015 11.015 3 13.5 3C13.68 3 13.857 3.01 14.032 3.03C12.32 3.26 11 4.727 11 6.5C11 8.433 12.567 10 14.5 10C16.274 10 17.74 8.68 17.97 6.968Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PL = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#DF0A37"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V8H0V0Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PS = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#007B3A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V15.033L10 7.5L0 0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PT = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FF0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#006700"
                />
                <path
                    d="M7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10Z"
                    fill="#FFFF00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 8V5H5V8C5 8.552 5.895 9 7 9C8.105 9 9 8.552 9 8Z"
                    fill="#FF0000"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 6H8V8H6V6Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 6H7V7H6V6ZM7 7H8V8H7V7Z"
                    fill="#002E9C"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PW = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#44ACD8"
                />
                <path
                    d="M9.5 12C11.9853 12 14 9.98528 14 7.5C14 5.01472 11.9853 3 9.5 3C7.01472 3 5 5.01472 5 7.5C5 9.98528 7.01472 12 9.5 12Z"
                    fill="#FFE000"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const PY = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#0033AB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.97 7.20001C11.99 7.29701 12 7.39701 12 7.50001C12 8.32801 11.328 9.00001 10.5 9.00001C9.672 9.00001 9 8.32801 9 7.50001C9 7.39701 9.01 7.29701 9.03 7.20001C9.17 7.65601 9.774 8.00001 10.5 8.00001C11.226 8.00001 11.83 7.65601 11.97 7.20001Z"
                    fill="#50B275"
                />
                <path
                    d="M10.5 7C10.7761 7 11 6.77614 11 6.5C11 6.22386 10.7761 6 10.5 6C10.2239 6 10 6.22386 10 6.5C10 6.77614 10.2239 7 10.5 7Z"
                    fill="#FFE100"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D7280F"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const QA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#8F183C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 0L8 1L5 2L8 3L5 4L8 5L5 6L8 7L5 8L8 9L5 10L8 11L5 12L8 13L5 14L8 15H0V0H5Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const RO = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FDD200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#002781"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const RS = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#0A4981"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0ZM8 10V5H4V10C4 11.105 4.895 12 6 12C7.105 12 8 11.105 8 10Z"
                    fill="#CD3E44"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 5L4 4C4 4 5 3 6 3C7 3 8 4 8 4L7 5H5Z"
                    fill="#ECBE34"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6L4 7L6 8L5 10L6 12L7 10L6 8L8 7L7 6L6 7L5 6Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 6H4V7L5 6ZM7 6H8V7L7 6Z"
                    fill="#ECBE34"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 3L5 4L6 5L7 4L6 3Z"
                    fill="#A75835"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 8L4 9H8L6 8Z"
                    fill="#88605F"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const RU = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#0034A9"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#D7280F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const RW = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FBD400"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#1D613C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V7H0V0Z"
                    fill="#00A0E1"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.974 3.974C17.57 3.908 18 3.72 18 3.5C18 3.28 17.57 3.092 16.974 3.026C16.908 2.43 16.72 2 16.5 2C16.28 2 16.092 2.43 16.026 3.026C15.43 3.092 15 3.28 15 3.5C15 3.72 15.43 3.908 16.026 3.974C16.092 4.57 16.28 5 16.5 5C16.72 5 16.908 4.57 16.974 3.974Z"
                    fill="#FBD400"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00773C"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 10V9.00001H4.99998L6.99998 10H13C13 10.552 13.672 11 14.5 11C15.328 11 16 10.552 16 10ZM8.72998 3.90601C8.71798 3.90601 8.69998 3.91201 8.67698 3.92601C8.62298 3.96201 8.51698 4.07301 8.51298 4.20101C8.50998 4.27401 8.49598 4.27401 8.54298 4.32101C8.57698 4.36901 8.61298 4.36501 8.68098 4.32801C8.72098 4.29801 8.73398 4.28101 8.74798 4.23201C8.76398 4.15201 8.66098 4.27201 8.64798 4.18001C8.62498 4.09601 8.69098 4.06001 8.75298 3.98001C8.75498 3.94001 8.75498 3.91001 8.72998 3.90801V3.90601ZM9.73298 3.91101C9.71298 3.91501 9.68998 3.94101 9.65698 3.99901C9.63398 4.06101 9.53298 4.15501 9.60698 4.34901C9.66498 4.47201 9.68998 4.67101 9.66298 4.89401C9.62098 4.95701 9.61298 4.97901 9.55798 5.04201C9.48198 5.12501 9.39798 5.10401 9.33598 5.07201C9.27598 5.03201 9.22998 5.01201 9.20298 4.88601C9.20798 4.68601 9.21998 4.35401 9.18298 4.28401C9.12898 4.17601 9.03898 4.21401 9.00098 4.24701C8.81798 4.41701 8.72698 4.70001 8.67098 4.92701C8.62098 5.09101 8.56598 5.04301 8.52798 4.97701C8.43498 4.88901 8.42798 4.20701 8.31598 4.32001C8.13598 4.83401 8.41898 5.39701 8.61598 5.34201C8.75598 5.40201 8.84598 5.13201 8.90398 4.83701C8.94398 4.75401 8.97398 4.74401 8.99398 4.78701C8.98898 5.17901 9.02398 5.26701 9.12398 5.38501C9.34798 5.55901 9.53398 5.40701 9.54898 5.39301L9.72398 5.21901C9.76398 5.17901 9.81398 5.17501 9.86898 5.21101C9.92298 5.26101 9.91598 5.34401 10.029 5.40101C10.127 5.44101 10.332 5.41101 10.379 5.32801C10.444 5.21801 10.459 5.18001 10.489 5.13801C10.535 5.07801 10.614 5.10501 10.614 5.12401C10.607 5.15901 10.561 5.19401 10.592 5.25401C10.647 5.29401 10.66 5.26801 10.692 5.25901C10.806 5.20501 10.892 4.95701 10.892 4.95701C10.897 4.86501 10.845 4.87201 10.812 4.89101C10.767 4.91801 10.765 4.92701 10.722 4.95401C10.665 4.96201 10.557 4.99901 10.504 4.91601C10.449 4.81601 10.449 4.67801 10.407 4.57601C10.407 4.57001 10.334 4.41901 10.401 4.41001C10.434 4.41601 10.508 4.43501 10.519 4.37401C10.555 4.31401 10.442 4.14401 10.365 4.06001C10.299 3.98701 10.207 3.97801 10.118 4.05201C10.055 4.11001 10.065 4.17401 10.052 4.23501C10.037 4.30501 10.04 4.39201 10.112 4.48501C10.174 4.60701 10.287 4.76501 10.249 4.98701C10.249 4.98701 10.184 5.09301 10.069 5.07901C10.019 5.06901 9.94098 5.04901 9.89898 4.73901C9.86898 4.50601 9.90698 4.17901 9.80898 4.02601C9.78598 3.96901 9.76698 3.91301 9.73498 3.91601L9.73298 3.91101ZM9.41498 3.93701C9.38498 3.94001 9.35198 3.97501 9.32498 4.04201C9.30198 4.09401 9.27298 4.36201 9.27798 4.36201C9.25798 4.44201 9.36098 4.47601 9.40798 4.37401C9.47798 4.18401 9.47798 4.10401 9.48198 4.02601C9.47198 3.96601 9.44498 3.93601 9.41498 3.93801V3.93701ZM10.588 3.95701C10.558 3.96101 10.533 3.97901 10.524 4.02501C10.511 4.13101 10.518 4.19001 10.536 4.27901C10.549 4.33901 10.636 4.43701 10.678 4.49501C10.881 4.76801 11.078 5.04201 11.266 5.32501C11.296 5.53701 11.316 5.74301 11.331 5.94901C11.363 6.39901 11.371 6.95901 11.344 7.43401C11.428 7.43701 11.564 7.29701 11.611 7.09401C11.641 6.81001 11.601 6.23401 11.597 6.06601L11.587 5.82801C11.807 6.18801 12.019 6.56801 12.227 6.98401C12.304 6.94801 12.287 6.51901 12.243 6.45901C12.075 6.09901 11.843 5.74301 11.77 5.60601C11.743 5.55601 11.652 5.41901 11.545 5.26001C11.525 5.03201 11.503 4.84001 11.489 4.78201C11.454 4.54201 11.587 4.80901 11.569 4.67001C11.525 4.43001 11.393 4.26801 11.237 4.04801C11.187 3.97801 11.187 3.96201 11.11 4.06601C11.065 4.17101 11.065 4.25901 11.08 4.34101C11.058 4.31101 11.033 4.27701 10.997 4.23301L10.742 4.01701C10.707 3.99201 10.639 3.95401 10.588 3.95701ZM14.064 3.99401C14.049 3.99201 14.034 3.99901 14.014 4.02601C13.979 4.05601 13.942 4.11301 13.944 4.18601C13.951 4.31101 13.974 4.44001 13.982 4.56601L13.992 4.61601C13.978 4.60001 13.966 4.58601 13.959 4.58001C13.712 4.32001 14.072 4.53601 13.911 4.33701C13.776 4.18701 13.736 4.14101 13.621 4.05101C13.561 4.01501 13.527 3.94301 13.508 4.06501C13.5 4.17201 13.492 4.29701 13.498 4.38701C13.498 4.43701 13.551 4.53201 13.596 4.58701C13.76 4.79001 13.928 5.00501 14.096 5.22901C14.132 5.68601 14.141 6.10501 14.176 6.56301C14.172 6.75901 14.112 7.01901 14.056 7.04301C14.056 7.04301 13.968 7.09301 13.91 7.03801C13.867 7.02101 13.698 6.75501 13.698 6.75501C13.611 6.67501 13.553 6.69801 13.492 6.75501C13.322 6.91901 13.244 7.22701 13.129 7.43901C13.099 7.48601 13.016 7.52701 12.923 7.43501C12.686 7.11101 12.823 6.65001 12.795 6.76901C12.585 7.00701 12.677 7.40101 12.725 7.48601C12.795 7.62601 12.851 7.71601 12.985 7.78301C13.11 7.87301 13.205 7.81801 13.259 7.75301C13.383 7.62501 13.385 7.29601 13.443 7.23101C13.483 7.11101 13.586 7.13101 13.636 7.18501C13.686 7.25501 13.742 7.30001 13.813 7.33801C13.929 7.44001 14.067 7.45801 14.203 7.36501C14.296 7.31301 14.357 7.24501 14.411 7.11101C14.471 6.95501 14.441 6.13501 14.428 5.67901L14.688 6.05501C14.724 6.45501 14.741 6.85001 14.728 7.22801C14.72 7.30301 14.991 7.00401 14.988 6.86201C14.988 6.73901 14.99 6.62601 14.988 6.52201C15.121 6.73201 15.248 6.94501 15.368 7.16201C15.443 7.12201 15.418 6.69901 15.371 6.64201C15.245 6.43001 15.083 6.20201 14.958 6.02401C14.933 5.80101 14.9 5.53801 14.884 5.45701C14.861 5.33101 14.837 5.14201 14.801 4.99301C14.791 4.93601 14.761 4.75001 14.771 4.73301C14.785 4.69001 14.841 4.73301 14.868 4.68501C14.908 4.64001 14.726 4.16501 14.633 4.03101C14.6 3.97101 14.539 3.99101 14.465 4.09101C14.395 4.15501 14.421 4.30301 14.447 4.44401C14.515 4.80401 14.577 5.16801 14.625 5.53401C14.535 5.39901 14.425 5.23701 14.317 5.08201L14.303 5.01201C14.303 5.00401 14.289 4.71701 14.276 4.64901C14.273 4.62101 14.266 4.61301 14.296 4.61701C14.326 4.64301 14.33 4.64401 14.349 4.65301C14.381 4.65701 14.409 4.60501 14.389 4.55601L14.099 4.02201C14.089 4.00901 14.075 3.99701 14.059 3.99501L14.064 3.99401ZM5.09398 4.00401C5.03898 4.00201 4.98098 4.03401 5.00398 4.09901C4.98998 4.13401 5.10798 4.25201 5.12898 4.31701C5.14598 4.36401 5.10898 4.51201 5.14898 4.52701C5.18398 4.54201 5.23298 4.42301 5.25098 4.31401C5.26098 4.25401 5.25398 4.04801 5.11398 4.00601C5.10698 4.00401 5.09998 4.00401 5.09198 4.00301L5.09398 4.00401ZM15.314 4.00401C15.301 4.00601 15.286 4.02401 15.264 4.07401C15.209 4.16401 15.19 4.32401 15.212 4.46401C15.342 5.35401 15.442 6.21601 15.462 7.00401C15.45 7.08001 15.446 7.12001 15.412 7.21401C15.334 7.31401 15.248 7.43801 15.167 7.49801C15.087 7.55801 14.915 7.61601 14.859 7.66001C14.679 7.76201 14.679 7.88001 14.823 7.88501C15.071 7.85501 15.365 7.83501 15.567 7.53001C15.621 7.44501 15.685 7.21301 15.687 7.07001C15.707 6.24001 15.677 5.42501 15.552 4.82401C15.544 4.76401 15.518 4.63101 15.528 4.61401C15.543 4.57201 15.624 4.61701 15.653 4.57001C15.696 4.52601 15.443 4.20301 15.355 4.06501C15.337 4.03101 15.325 4.00201 15.311 4.00501L15.314 4.00401ZM12.711 4.01801C12.701 4.02001 12.687 4.03601 12.659 4.07301C12.589 4.29901 12.565 4.48301 12.592 4.62501C12.772 5.55501 12.952 6.40001 12.924 7.28501C13.008 7.28501 13.106 7.09201 13.148 6.90001C13.171 6.63501 13.132 6.47401 13.126 6.32001C13.119 6.16401 12.95 4.90401 12.916 4.78701C12.874 4.56501 13.08 4.75701 13.058 4.62901C12.986 4.46501 12.808 4.22901 12.754 4.08601C12.734 4.04801 12.73 4.01301 12.714 4.01601L12.711 4.01801ZM6.37698 4.03601C6.35698 4.04001 6.33398 4.05801 6.32698 4.08601C6.32198 4.10601 6.33498 4.13901 6.31698 4.14901C6.30698 4.15901 6.26898 4.15201 6.27098 4.09901C6.27098 4.08101 6.25798 4.06301 6.25098 4.05201C6.24298 4.04801 6.23798 4.04701 6.22398 4.04701C6.20698 4.04701 6.20698 4.05201 6.19798 4.06701C6.19398 4.08101 6.18798 4.09501 6.18798 4.11101C6.18598 4.13101 6.17798 4.13601 6.16498 4.13901C6.14898 4.13901 6.15198 4.14101 6.13998 4.13201C6.12998 4.12501 6.12198 4.12201 6.12198 4.10801C6.12198 4.09301 6.11798 4.06801 6.11398 4.06001C6.10698 4.05001 6.09598 4.04601 6.08398 4.04301C6.01798 4.04301 6.01398 4.12101 6.01698 4.14901C6.01198 4.15501 6.00998 4.28901 6.09998 4.32701C6.21998 4.38501 6.44798 4.36001 6.43998 4.16501C6.43998 4.14801 6.43498 4.09001 6.43298 4.07501C6.42098 4.04501 6.39798 4.03501 6.37598 4.03801L6.37698 4.03601ZM8.00298 4.03801C7.96098 4.04001 7.92298 4.05201 7.89298 4.06801C7.81298 4.14501 7.79298 4.26801 7.85698 4.34501C7.91698 4.37501 7.97998 4.43501 7.93898 4.47001C7.76498 4.65501 7.31198 4.96601 7.28898 5.02301V5.02901H7.29298V5.03101C7.31598 5.04601 7.59998 5.04601 7.63098 5.03101H7.63298C7.73098 4.99401 8.19298 4.46601 8.19298 4.46601C8.16898 4.44601 8.14698 4.43001 8.12298 4.40901C8.09698 4.38701 8.09998 4.36501 8.12298 4.34301C8.23698 4.27701 8.20098 4.13001 8.14098 4.06301C8.09098 4.04101 8.04498 4.03301 8.00298 4.03601V4.03801ZM12.253 4.03801C12.241 4.04101 12.226 4.05801 12.203 4.10801C12.148 4.19801 12.111 4.35301 12.116 4.49801C12.234 5.31801 12.27 6.03501 12.348 6.85501C12.354 6.93501 12.342 7.04901 12.29 7.09501C12.094 7.29901 11.813 7.54901 11.507 7.66501C11.474 7.70201 11.589 7.85901 11.737 7.85901C11.985 7.82901 12.203 7.69101 12.407 7.32401C12.46 7.23901 12.555 7.05601 12.557 6.91401C12.577 6.08201 12.517 5.43401 12.391 4.83401C12.384 4.77401 12.389 4.70401 12.399 4.68801C12.415 4.66801 12.469 4.68801 12.499 4.64101C12.541 4.59701 12.385 4.23801 12.297 4.10101C12.279 4.06601 12.269 4.03801 12.253 4.03901V4.03801ZM5.66898 4.06501C5.63498 4.06901 5.60298 4.09501 5.58698 4.13501C5.58198 4.26501 5.58098 4.39501 5.59698 4.51701C5.65698 4.73001 5.67398 4.91701 5.70298 5.13401C5.71298 5.42601 5.53498 5.26001 5.54298 5.11601C5.58298 4.92801 5.57298 4.63301 5.53698 4.55801C5.50698 4.48301 5.47498 4.46501 5.40498 4.47801C5.34998 4.47401 5.20698 4.62801 5.16698 4.88801C5.16698 4.88801 5.13298 5.02001 5.11898 5.13801C5.09898 5.27101 5.01098 5.36601 4.94898 5.12001C4.89598 4.94001 4.86398 4.50001 4.77498 4.60201C4.74898 4.94601 4.71898 5.55201 5.01098 5.61401C5.36498 5.64801 5.16898 5.01601 5.29698 4.90101C5.32198 4.84601 5.36698 4.84501 5.36998 4.91601V5.45301C5.36598 5.62701 5.47998 5.67901 5.56998 5.71501C5.66298 5.70801 5.72398 5.71101 5.75998 5.80101L5.80498 6.73101C5.80498 6.73101 6.01898 6.79101 6.02898 6.20801C6.03898 5.86501 5.95898 5.57801 6.00598 5.51101C6.00798 5.44501 6.09198 5.44101 6.14998 5.47401C6.24298 5.53901 6.28398 5.61901 6.42798 5.58701C6.64798 5.52701 6.77798 5.42101 6.78098 5.25301C6.77098 5.09301 6.75098 4.93301 6.68098 4.77301C6.69098 4.74501 6.64098 4.67001 6.65098 4.64101C6.68898 4.70101 6.74898 4.69701 6.76098 4.64101C6.72498 4.51801 6.66698 4.40101 6.57298 4.35101C6.49598 4.28101 6.38298 4.29601 6.34098 4.43801C6.32098 4.60201 6.40098 4.79601 6.52098 4.95501C6.54498 5.01701 6.58098 5.12001 6.56498 5.21301C6.50198 5.24901 6.43898 5.23301 6.38498 5.17801C6.38498 5.17801 6.21198 5.04801 6.21198 5.01801C6.25898 4.72301 6.22198 4.68801 6.19698 4.60801C6.17898 4.49401 6.12498 4.45801 6.08198 4.38001C6.03798 4.33301 5.97898 4.33301 5.95198 4.38001C5.87398 4.51301 5.90998 4.80001 5.96598 4.92701C6.00598 5.04501 6.06798 5.11901 6.03898 5.11901C6.01498 5.18401 5.96498 5.16901 5.92898 5.09201C5.87898 4.93201 5.86698 4.69601 5.86698 4.58901C5.85198 4.45701 5.83498 4.17401 5.74698 4.10201C5.72398 4.07001 5.69698 4.05901 5.66998 4.06201L5.66898 4.06501ZM6.91098 4.06501C6.89398 4.06901 6.87398 4.07901 6.85098 4.08501C6.77598 4.10801 6.70598 4.17301 6.72798 4.29901C6.81798 4.83901 6.87498 5.25201 6.96398 5.79201C6.97698 5.85601 6.92398 5.93901 6.85598 5.93201C6.73998 5.85201 6.71098 5.69201 6.51298 5.70001C6.36898 5.70001 6.20498 5.85801 6.18498 6.00801C6.16098 6.12801 6.15298 6.25801 6.18498 6.36201C6.28498 6.48201 6.40698 6.47001 6.51298 6.44201C6.59998 6.40701 6.67298 6.32201 6.70298 6.34201C6.72298 6.37501 6.70098 6.65601 6.29298 6.87201C6.04098 6.98601 5.84098 7.01201 5.73298 6.80801C5.66698 6.68001 5.73898 6.19201 5.57498 6.30401C5.08898 7.55601 6.71198 7.73001 6.89298 6.35601C6.90498 6.31601 6.93998 6.27801 6.96598 6.28801C6.97598 6.29301 6.98598 6.30801 6.98998 6.33601C6.95198 7.58001 5.73398 7.66601 5.52798 7.27401C5.47598 7.18201 5.46098 6.97601 5.45598 6.85401C5.44598 6.77901 5.42798 6.73601 5.40598 6.71901C5.35598 6.68201 5.28998 6.77901 5.27598 6.94601C5.25598 7.08101 5.26098 7.11801 5.26098 7.24801C5.32698 8.23101 6.89398 7.80801 7.14898 6.99801C7.27498 6.57801 7.14598 6.26101 7.18898 6.22201L7.19198 6.22001H7.19498L7.19998 6.21801C7.35598 6.38601 7.57398 6.23801 7.62198 6.18101C7.64198 6.15101 7.69398 6.13101 7.72998 6.17101C7.84998 6.25701 8.06398 6.21601 8.10798 6.06101C8.13398 5.91101 8.15598 5.75701 8.16098 5.59601C8.08098 5.62101 8.01698 5.63901 7.99098 5.66601C7.98498 5.67301 7.98098 5.68101 7.97898 5.68901L7.95898 5.82201C7.95898 5.82701 7.95698 5.83001 7.95498 5.83201C7.95198 5.83901 7.94498 5.84401 7.94098 5.84701C7.91298 5.86201 7.86398 5.85401 7.86098 5.81301C7.82398 5.64301 7.66898 5.62101 7.57498 5.88601C7.51198 5.93601 7.39498 5.94601 7.38498 5.87001C7.39998 5.69201 7.32798 5.66801 7.18498 5.75201L7.04698 4.71201C7.10698 4.70901 7.16098 4.75201 7.21698 4.68401C7.15698 4.50001 7.03198 4.12601 6.96098 4.09001H6.95898L6.94898 4.08001C6.94898 4.07801 6.94598 4.07701 6.94398 4.07601L6.93998 4.07001C6.93598 4.07001 6.93198 4.06801 6.92998 4.06701C6.92298 4.06501 6.91698 4.06501 6.90998 4.06501H6.91098ZM11.753 4.06901C11.691 4.06701 11.623 4.10601 11.649 4.18401C11.633 4.22701 11.782 4.37101 11.806 4.44901C11.849 4.56901 11.773 4.68601 11.818 4.70301C11.86 4.72101 11.918 4.57801 11.938 4.44501C11.964 4.33701 11.888 4.11701 11.778 4.07201L11.753 4.07001V4.06901ZM7.97998 4.20001C8.00798 4.19801 8.04198 4.22401 8.05998 4.26001C8.07698 4.30001 8.06798 4.33701 8.03998 4.34401C8.00998 4.35101 7.97198 4.32601 7.95398 4.28601C7.93598 4.24601 7.94398 4.20901 7.97398 4.20201H7.97998V4.20001ZM14.977 4.38201C14.92 4.38001 14.857 4.42201 14.883 4.50701C14.869 4.55301 15.003 4.70901 15.026 4.79501C15.046 4.85501 14.996 5.05101 15.036 5.06901C15.074 5.08901 15.126 4.93301 15.146 4.78901C15.158 4.70901 15.1 4.43401 15.001 4.38501C14.994 4.38301 14.986 4.38101 14.978 4.38101L14.977 4.38201ZM11.107 4.47801C11.114 4.50101 11.119 4.52401 11.122 4.54801C11.134 4.59801 11.144 4.64801 11.154 4.70001C11.11 4.63801 11.074 4.58801 11.057 4.57001C10.957 4.45001 11.059 4.49201 11.107 4.47801ZM12 4.91601C11.978 4.92001 11.957 4.93901 11.95 4.96901C11.944 4.98701 11.958 5.01901 11.94 5.02901C11.93 5.03901 11.89 5.03301 11.893 4.97901C11.893 4.96101 11.88 4.94201 11.873 4.93201C11.865 4.92701 11.86 4.92501 11.846 4.92501C11.829 4.92501 11.829 4.93001 11.82 4.94501C11.816 4.95901 11.81 4.97301 11.81 4.99001C11.81 5.01001 11.802 5.01601 11.788 5.02001C11.772 5.02001 11.775 5.02001 11.762 5.01301C11.754 5.00301 11.745 5.00101 11.745 4.98701C11.745 4.97201 11.742 4.94901 11.737 4.93901C11.73 4.92901 11.72 4.92601 11.707 4.92201C11.642 4.92201 11.637 4.99801 11.641 5.02601C11.637 5.03201 11.634 5.16801 11.724 5.20601C11.846 5.26301 12.074 5.23601 12.064 5.04201C12.064 5.02501 12.059 4.96701 12.058 4.95201C12.045 4.92201 12.022 4.91201 12.001 4.91501L12 4.91601ZM7.92998 4.95601C7.91598 4.95601 7.89598 4.96001 7.87298 4.97401C7.76598 5.03201 7.72498 5.20401 7.79298 5.30401C7.85298 5.39401 7.95298 5.36101 7.96598 5.36101C8.07098 5.37501 8.13298 5.16501 8.13298 5.16501C8.13298 5.16501 8.13598 5.10501 8.01298 5.21701C7.95898 5.22701 7.95298 5.20701 7.93898 5.17701C7.92698 5.12401 7.92898 5.06701 7.95398 5.01401C7.96598 4.98101 7.95398 4.96001 7.92998 4.95801V4.95601ZM13.683 4.98301C13.623 4.98001 13.56 5.01901 13.543 5.10001C13.543 5.14801 13.565 5.17401 13.561 5.21801C13.556 5.24301 13.531 5.25801 13.469 5.23001C13.479 5.22001 13.429 5.15201 13.429 5.15201C13.382 5.12201 13.319 5.15201 13.277 5.18001C13.254 5.22201 13.237 5.29301 13.263 5.36501C13.331 5.49201 13.566 5.70801 13.678 5.71001C13.68 5.59601 13.691 5.44401 13.698 5.35001C13.7 5.31401 13.708 5.27501 13.743 5.26601C13.777 5.25601 13.836 5.30001 13.836 5.26301C13.83 5.19101 13.816 5.08301 13.776 5.03301C13.754 5.00301 13.719 4.98501 13.684 4.98301H13.683ZM8.91998 5.38001L8.91698 5.38301C8.91698 5.38301 8.91498 5.38301 8.91398 5.38501C8.90198 5.39501 8.88798 5.41501 8.85698 5.43501C8.80398 5.49501 8.79498 5.53801 8.79698 5.65801C8.80098 5.67101 8.89698 5.94101 8.97998 6.13001C9.03598 6.32701 9.08698 6.55301 9.04998 6.76601C8.91998 7.04801 8.65998 7.30101 8.40698 7.43901C8.27698 7.47901 8.16698 7.46501 8.13698 7.43701C8.06298 7.38701 8.06198 7.29701 8.06698 7.28301V7.28001C8.27898 7.13201 8.52198 7.01201 8.71198 6.61301C8.76798 6.46001 8.78598 6.36801 8.72998 6.13301C8.70798 6.04301 8.67998 5.97301 8.61998 5.90901H8.62198C8.65798 5.89201 8.75198 5.96101 8.76698 5.91901C8.74398 5.80501 8.66698 5.65401 8.58198 5.57601C8.50598 5.50601 8.42198 5.49901 8.35398 5.56201C8.27598 5.60601 8.25998 5.76201 8.29698 5.89801C8.33898 6.00001 8.45198 6.01801 8.53198 6.22501C8.53398 6.23901 8.55898 6.38001 8.51898 6.43801C8.48498 6.54001 8.06398 6.87201 8.03398 6.89201L8.03098 6.89401L8.02898 6.89601H8.02698H8.02498V6.89301C8.02298 6.88501 8.02498 6.86301 8.02498 6.83001C8.02198 6.76801 8.04798 6.62701 8.04498 6.60201V6.60001C7.90498 6.69001 7.85798 6.96501 7.83298 7.04701C7.47998 7.29001 7.07998 7.47101 6.84898 7.71701C6.72898 7.90701 7.67698 7.50301 7.78698 7.45401L7.78998 7.45701C7.81198 7.48001 7.81298 7.56001 7.87598 7.63301C7.97598 7.76601 8.18398 7.84801 8.38798 7.79701C8.72998 7.67401 8.92798 7.44101 9.12798 7.18201C9.15598 7.14201 9.20098 7.10801 9.24298 7.14001C9.37998 7.44801 9.77798 7.66801 10.291 7.69001C10.411 7.54601 10.354 7.47501 10.306 7.44501C10.291 7.43501 10.051 7.34101 10.013 7.24801C9.98998 7.16201 10.047 7.08501 10.161 7.02801C10.491 6.98801 10.815 6.94301 11.129 6.84201C11.132 6.73601 11.194 6.57901 11.236 6.51001C11.266 6.46301 11.283 6.45801 11.29 6.45201V6.45001H11.292V6.44701V6.43701L11.238 6.40501L10.185 6.40101C10.172 6.39601 10.163 6.39101 10.157 6.38601L10.155 6.38301C10.155 6.38301 10.153 6.38301 10.153 6.38101C10.153 6.37901 10.151 6.37901 10.151 6.37901V6.38001V6.37801V6.37601V6.37401L10.153 6.37101C10.158 6.36501 10.171 6.35801 10.186 6.35101C10.438 6.31801 10.884 6.24501 10.914 5.81601C10.909 5.59201 10.818 5.44601 10.544 5.40601C10.342 5.42101 10.198 5.61601 10.221 5.83001C10.211 5.88701 10.241 6.00001 10.181 6.01301C9.79498 6.04901 9.37298 6.29101 9.35898 6.46501H9.35698H9.35498H9.35298C9.35298 6.46701 9.35098 6.46701 9.34998 6.46701H9.34598H9.34398H9.33998C9.31498 6.45901 9.28298 6.41701 9.28798 6.36001C9.27298 6.06001 9.17498 5.72001 9.02298 5.46001C8.96798 5.40501 8.94298 5.38301 8.92898 5.38001H8.92598H8.92298H8.92098H8.91998ZM9.92798 5.53801C9.90798 5.54201 9.88498 5.56001 9.87798 5.59001C9.87298 5.61001 9.88798 5.64201 9.86998 5.65201C9.85998 5.66201 9.81998 5.65601 9.82198 5.60201C9.82198 5.58501 9.80898 5.56601 9.80198 5.55501C9.79398 5.55001 9.78898 5.54901 9.77598 5.54901C9.75898 5.54901 9.75798 5.55301 9.74898 5.56701C9.74398 5.58101 9.73898 5.59701 9.73898 5.61201C9.73698 5.63201 9.72898 5.63801 9.71598 5.64001C9.69998 5.64001 9.70398 5.64301 9.69098 5.63501C9.68298 5.62701 9.67298 5.62301 9.67298 5.60901C9.67298 5.59401 9.66998 5.56901 9.66598 5.55901C9.65898 5.55201 9.64798 5.54901 9.63598 5.54501C9.56898 5.54501 9.56598 5.62001 9.56898 5.64901C9.56398 5.65401 9.56098 5.78901 9.65098 5.82701C9.77098 5.88501 10.061 5.85101 9.99098 5.66401C9.99098 5.64701 9.98598 5.58901 9.98498 5.57401C9.97198 5.54401 9.94898 5.53401 9.92698 5.53701L9.92798 5.53801ZM13.993 5.70501H13.983C13.983 5.70501 13.421 6.10501 13.408 6.11901C13.352 6.16901 13.38 6.34201 13.408 6.32201C13.448 6.33701 14.013 5.95401 14.002 5.90901C14.027 5.91101 14.039 5.71201 13.992 5.70401L13.993 5.70501ZM10.459 5.76501C10.481 5.76201 10.511 5.77001 10.539 5.78501C10.582 5.81101 10.609 5.84701 10.604 5.87501V5.87901C10.602 5.87901 10.602 5.87901 10.602 5.88101V5.88301C10.602 5.88301 10.6 5.88301 10.6 5.88501C10.6 5.88701 10.597 5.88901 10.595 5.89101C10.575 5.91101 10.529 5.90701 10.485 5.88101C10.443 5.85801 10.418 5.82101 10.42 5.79501V5.79201L10.425 5.78201C10.425 5.78201 10.425 5.78001 10.427 5.77901L10.432 5.77301C10.439 5.76801 10.448 5.76301 10.459 5.76301V5.76501ZM5.54098 5.86501C5.25098 5.87101 4.82398 6.24701 4.81298 6.45501L5.73298 6.01501C5.68298 5.93901 5.72998 5.87101 5.54098 5.86501ZM6.48398 5.99501C6.51198 5.99701 6.54198 6.01101 6.55798 6.05101C6.57198 6.08801 6.55798 6.12601 6.54098 6.14501V6.14801C6.52698 6.16401 6.48498 6.15801 6.45398 6.15801C6.41698 6.15601 6.39898 6.15001 6.37698 6.12001C6.36498 6.08501 6.39698 6.05201 6.41198 6.02801L6.41898 6.01801C6.42898 6.00801 6.44898 6.00001 6.46898 5.99801L6.48198 5.99601L6.48398 5.99501ZM13.884 6.11201C13.831 6.11801 13.782 6.16701 13.804 6.24501C13.79 6.29101 13.874 6.45201 13.897 6.53701C13.917 6.59701 13.871 6.77001 13.912 6.78701C13.95 6.80701 14.049 6.68701 14.046 6.53301C14.056 6.45301 14.018 6.16301 13.919 6.11501C13.907 6.11201 13.895 6.11101 13.883 6.11201H13.884ZM7.59998 6.39601C7.55398 6.39901 7.51298 6.42301 7.53198 6.48801C7.52898 6.53401 7.66198 6.59101 7.66898 6.69801C7.68698 6.74401 7.63898 6.88801 7.67898 6.90001C7.71498 6.91501 7.76498 6.80001 7.78398 6.69601C7.79398 6.63801 7.73798 6.43601 7.64398 6.39901C7.62898 6.39501 7.61398 6.39401 7.59898 6.39501L7.59998 6.39601ZM9.47998 6.65201H9.49198C9.60998 6.68401 9.78198 6.68801 9.93198 6.70201C10.055 6.71201 10.115 6.80601 10.002 6.84701C9.88798 6.88501 9.77898 6.91701 9.77898 7.07901C9.79298 7.15901 9.78898 7.20101 9.77698 7.21901C9.77698 7.22201 9.77398 7.22401 9.77298 7.22501C9.77298 7.22501 9.77298 7.22701 9.77098 7.22701V7.22901H9.76798L9.76098 7.23201H9.75598C9.72898 7.23701 9.68998 7.21201 9.66098 7.19601C9.59098 7.14601 9.39598 7.02601 9.36798 6.76601C9.36398 6.70601 9.40798 6.65601 9.47798 6.65101L9.47998 6.65201ZM4.88598 6.85201C4.87898 6.85201 4.86598 6.87401 4.84598 6.89901C4.67198 7.17401 4.65598 7.58501 4.75198 7.70901C4.80198 7.76601 4.88598 7.79201 4.94798 7.77401C5.05798 7.72701 5.10498 7.50601 5.07798 7.42601C5.04298 7.36901 5.01398 7.36001 4.97798 7.40801C4.90098 7.56301 4.86798 7.45601 4.86298 7.36801C4.85098 7.20501 4.86698 7.05301 4.88498 6.93301C4.89498 6.87301 4.89498 6.85001 4.88498 6.85001L4.88598 6.85201ZM10.783 7.21401C10.77 7.21401 10.757 7.21601 10.743 7.22401C10.74 7.22401 10.619 7.30401 10.58 7.36201C10.556 7.38001 10.56 7.39501 10.566 7.42701C10.584 7.47001 10.616 7.45701 10.654 7.43701C10.704 7.42901 10.727 7.46201 10.724 7.52101C10.701 7.59601 10.734 7.62301 10.734 7.62801C10.734 7.63201 10.781 7.67301 10.837 7.64101C10.954 7.59601 11.027 7.55101 11.192 7.51601C11.235 7.51601 11.232 7.40001 11.164 7.39601C11.074 7.40001 10.994 7.40601 10.904 7.47601C10.849 7.48801 10.84 7.45401 10.827 7.42401C10.813 7.35001 10.859 7.29801 10.849 7.24201C10.851 7.24501 10.821 7.21801 10.782 7.21601L10.783 7.21401ZM14.559 7.35401L14.479 7.36201C14.443 7.36901 14.431 7.38501 14.424 7.42901C14.427 7.49401 14.467 7.49101 14.509 7.51701C14.533 7.54701 14.549 7.57501 14.507 7.62701C14.467 7.66201 14.44 7.68201 14.4 7.71701C14.383 7.74901 14.37 7.79701 14.428 7.81301C14.533 7.84301 14.776 7.68501 14.776 7.68301C14.816 7.65301 14.802 7.59601 14.799 7.59601C14.775 7.57001 14.723 7.58601 14.689 7.58101C14.672 7.58101 14.619 7.57301 14.643 7.52501C14.665 7.49501 14.673 7.47801 14.688 7.44101C14.703 7.40501 14.688 7.38101 14.63 7.36101C14.6 7.35501 14.58 7.35301 14.557 7.35401H14.559ZM13.106 11.214C13.376 11.227 13.628 11.217 13.896 11.23C13.94 11.266 13.919 11.35 13.891 11.364L13.886 11.366H13.883H13.879L13.653 11.36V11.347C13.631 11.285 13.481 11.289 13.445 11.337V11.34C13.443 11.34 13.442 11.343 13.442 11.344L13.44 11.349V11.361C13.32 11.376 13.215 11.357 13.097 11.353C13.062 11.31 13.067 11.233 13.107 11.213L13.106 11.214Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SB = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#025BC2"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15H21V0L0 15Z"
                    fill="#FCD715"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 15H21V2L2 15Z"
                    fill="#24663A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.12201 5.658L4.50401 6L4.62201 5.276L4.12201 4.764L4.81201 4.658L5.12201 4L5.43201 4.658L6.12201 4.764L5.62201 5.276L5.74001 6L5.12201 5.658ZM3.12201 3.658L2.50401 4L2.62201 3.276L2.12201 2.764L2.81201 2.658L3.12201 2L3.43201 2.658L4.12201 2.764L3.62201 3.276L3.74001 4L3.12201 3.658ZM7.12201 3.658L6.50401 4L6.62201 3.276L6.12201 2.764L6.81201 2.658L7.12201 2L7.43201 2.658L8.12201 2.764L7.62201 3.276L7.74001 4L7.12201 3.658ZM7.12201 7.658L6.50401 8L6.62201 7.276L6.12201 6.764L6.81201 6.658L7.12201 6L7.43201 6.658L8.12201 6.764L7.62201 7.276L7.74001 8L7.12201 7.658ZM3.12201 7.658L2.50401 8L2.62201 7.276L2.12201 6.764L2.81201 6.658L3.12201 6L3.43201 6.658L4.12201 6.764L3.62201 7.276L3.74001 8L3.12201 7.658Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SC = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FCDD60"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L9 0H0V15Z"
                    fill="#024892"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L16 0H21V4L0 15Z"
                    fill="#DB2E2D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L21 9V4L0 15Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L21 9V15H0Z"
                    fill="#008545"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SD = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D70F3B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V15.033L10 7.5L0 0Z"
                    fill="#007D2E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#0275B0"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 9H0V6H6V0H9V6H21V9H9V15H6V9Z"
                    fill="#FED200"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V9H0V0Z"
                    fill="#EF2F41"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 7.863C5.71 7.953 5.4 8 5.077 8C3.377 8 2 6.657 2 5C2 3.343 3.378 2 5.077 2C5.399 2 5.709 2.048 6 2.137C4.752 2.52 3.846 3.657 3.846 5C3.846 6.343 4.752 7.48 6 7.863ZM8 3H9V4H8V3ZM10 4H11V5H10V4ZM9 6H10V7H9V6ZM6 4H7V5H6V4ZM7 6H8V7H7V6Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SI = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#0268AE"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#EF1F28"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="white"
                />
                <path
                    d="M6.5 3H4.5C3.94772 3 3.5 3.44772 3.5 4V6.5C3.5 7.05228 3.94772 7.5 4.5 7.5H6.5C7.05228 7.5 7.5 7.05228 7.5 6.5V4C7.5 3.44772 7.05228 3 6.5 3Z"
                    fill="#EF1F28"
                />
                <path
                    d="M6 3H5C4.44772 3 4 3.44772 4 4V6C4 6.55228 4.44772 7 5 7H6C6.55228 7 7 6.55228 7 6V4C7 3.44772 6.55228 3 6 3Z"
                    fill="#0268AE"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 4H6V5H5V4Z"
                    fill="#FFE200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 6L5.5 5.5L7 6L6 7H5L4 6Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SK = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#0A58AC"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#F01F29"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0ZM9.93 10H10V5H3V10H3.07C3.024 10.162 3 10.33 3 10.5C3 11.88 6.5 13 6.5 13C6.5 13 10 11.88 10 10.5C10 10.33 9.976 10.162 9.93 10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 10V4H4V10C4 11.105 6.5 12 6.5 12C6.5 12 9 11.105 9 10Z"
                    fill="#F01F29"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 8V7H5V6H6V5H7V6H8V7H7V8H8.5V9H7V10H6V9H4.5V8H6Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.5 12C6.5 12 9 11.105 9 10C9 8.89501 8 9.00001 6.5 10C5 9.00001 4 8.89501 4 10C4 11.105 6.5 12 6.5 12Z"
                    fill="#0A58AC"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SL = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#027DCD"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#20BD42"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 7H21V15H0V7Z"
                    fill="#69BEE7"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4H13V5L10.5 6L8 5V4Z"
                    fill="#E6BD34"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 8.5C13 7.12 11.88 6 10.5 6C9.12 6 8 7.12 8 8.5C8 9.88 9.12 11 10.5 11C11.88 11 13 9.88 13 8.5ZM10.5 10C11.328 10 12 9.105 12 8C12 6.895 11.328 6 10.5 6C9.672 6 9 6.895 9 8C9 9.105 9.672 10 10.5 10Z"
                    fill="#406421"
                />
                <path
                    d="M10.5 9C10.7761 9 11 8.55228 11 8C11 7.44772 10.7761 7 10.5 7C10.2239 7 10 7.44772 10 8C10 8.55228 10.2239 9 10.5 9Z"
                    fill="#D5B852"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FDF14B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#009048"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#E71E27"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.4999 8.75L9.02995 9.523L9.30995 7.886L8.12195 6.726L9.76495 6.489L10.4999 5L11.2349 6.49L12.8779 6.727L11.6879 7.887L11.9679 9.523"
                    fill="#009048"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SO = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#4A94E1"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.502 9.33L8.41201 10.43L8.81201 8.103L7.12201 6.456L9.45801 6.116L10.502 4L11.547 6.116L13.882 6.456L12.192 8.103L12.592 10.429"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11ZM0 0H21V4H0V0Z"
                    fill="#3F8948"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5H21V10H0V5Z"
                    fill="#BC0A33"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 8.75L9.03001 9.523L9.31001 7.886L8.12201 6.726L9.76501 6.489L10.5 5L11.235 6.49L12.878 6.727L11.688 7.887L11.968 9.523"
                    fill="#EECF1F"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SS = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V4H0V0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#059437"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5H21V10H0V5Z"
                    fill="#DF121B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L12 7.5L0 15V0Z"
                    fill="#0E50B8"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.73299 8.73202L3.40299 9.72502L3.42299 8.06501L2.06799 7.10502L3.65299 6.61302L4.14599 5.02802L5.10599 6.38302L6.76599 6.36302L5.77199 7.69302L6.30499 9.26502L4.73299 8.73202Z"
                    fill="#FCE206"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ST = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFD400"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11V15H21V11H0ZM0 0V4H21V0H0Z"
                    fill="#10B630"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0V15.033L7 7.5L0 0Z"
                    fill="#D70F3B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 8.42L9.35501 9.023L9.57501 7.748L8.64801 6.845L9.92801 6.66L10.5 5.5L11.072 6.66L12.352 6.845L11.426 7.748L11.646 9.023L10.5 8.42ZM16.5 8.42L15.355 9.023L15.575 7.748L14.648 6.845L15.928 6.66L16.5 5.5L17.072 6.66L18.352 6.845L17.426 7.748L17.646 9.023"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SV = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10ZM0 0H21V5H0V0Z"
                    fill="#0643B2"
                />
                <path
                    d="M10.5 9C11.3284 9 12 8.32843 12 7.5C12 6.67157 11.3284 6 10.5 6C9.67157 6 9 6.67157 9 7.5C9 8.32843 9.67157 9 10.5 9Z"
                    fill="#0017A2"
                />
                <path
                    d="M10.5 8C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7C10.2239 7 10 7.22386 10 7.5C10 7.77614 10.2239 8 10.5 8Z"
                    fill="#FFCD00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 7L9 8L10.5 9L12 8L13 7L12 9H9L8 7Z"
                    fill="#22551E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SX = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#012A87"
                />
                <path d="M21 0H0V7H21V0Z" fill="#DC171D" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L10 7.5L0 15V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 5H3L4 6L5 5H7L5 6H3L1 5Z"
                    fill="#BC725D"
                />
                <path
                    d="M4 10C4.55228 10 5 9.10457 5 8C5 6.89543 4.55228 6 4 6C3.44772 6 3 6.89543 3 8C3 9.10457 3.44772 10 4 10Z"
                    fill="#62AFE1"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 7V9H4H5V7L6 9L5 10H3L2 9L3 7Z"
                    fill="#FFDF00"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SY = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D4112A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.49995 8.75L5.02995 9.523L5.30995 7.886L4.12195 6.726L5.76495 6.489L6.49995 5L7.23495 6.49L8.87795 6.727L7.68795 7.887L7.96795 9.523L6.49995 8.75ZM14.4999 8.75L13.0299 9.523L13.3099 7.886L12.1219 6.726L13.7649 6.489L14.4999 5L15.2349 6.49L16.8779 6.727L15.6879 7.887L15.9679 9.523"
                    fill="#048849"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const SZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFDE00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 12H21V15H0V12ZM0 0H21V3H0V0Z"
                    fill="#4769C1"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4H21V11H0V4Z"
                    fill="#BC0A33"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4 8H17V9H4V8ZM6 6H16V7H6V6Z"
                    fill="#E1C400"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 6H18V7H16V6Z"
                    fill="#9D9191"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 10C12.985 10 15 7.5 15 7.5C15 7.5 12.985 5 10.5 5C8.015 5 6 7.5 6 7.5C6 7.5 8.015 10 10.5 10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 10C11 10 12 7.5 12 7.5C12 7.5 11 5 10.5 5C8.015 5 6 7.5 6 7.5C6 7.5 8.015 10 10.5 10Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 7H9V8H8V7ZM10 7H11V8H10V7Z"
                    fill="#878787"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 7H14V8H13V7Z"
                    fill="#5B5B5B"
                    stroke="#979797"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TD = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFCC00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H7V15H0V0Z"
                    fill="#002466"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 0H21V15H14V0Z"
                    fill="#C8032B"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFD400"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 0H21V3H7V0ZM7 6H21V9H7V6ZM0 12H21V15H0V12Z"
                    fill="#007558"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H9V9H0V0Z"
                    fill="#D70F3B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.44 5.89699L2.932 6.68999L3.22 5.00999L2 3.82299L3.686 3.57799L4.44 2.04999L5.194 3.57699L6.88 3.82199L5.66 5.01199L5.948 6.68999"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TH = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V3H0V0ZM0 12H21V15H0V12Z"
                    fill="#EF1F28"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5H21V10H0V5Z"
                    fill="#291F59"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TJ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#007100"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.97 7.2C11.99 7.297 12 7.397 12 7.5C12 8.328 11.328 9 10.5 9C9.672 9 9 8.328 9 7.5C9 7.397 9.01 7.297 9.03 7.2C9.17 7.656 9.774 8 10.5 8C11.226 8 11.83 7.656 11.97 7.2ZM10.5 7C10.776 7 11 6.776 11 6.5C11 6.224 10.776 6 10.5 6C10.224 6 10 6.224 10 6.5C10 6.776 10.224 7 10.5 7Z"
                    fill="#F9CA00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D20200"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TL = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#DE2110"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L14 7.5L0 15V0Z"
                    fill="#FFC800"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L10 7.5L0 15V0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.50001 8.75L2.03001 9.523L2.31001 7.886L1.12201 6.726L2.76501 6.489L3.50001 5L4.23501 6.49L5.87801 6.727L4.68801 7.887L4.96801 9.523"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#2DB771"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2 0H3V15H2V0ZM4 0H5V15H4V0ZM6 0H7V15H6V0Z"
                    fill="#D4B339"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 0L7 1.5L5 3V0ZM5 3L7 4.5L5 6V3ZM5 6L7 7.5L5 9V6ZM5 9L7 10.5L5 12V9ZM5 12L7 13.5L5 15V12ZM4 0L2 1.5L4 3V0ZM4 3L2 4.5L4 6V3ZM4 6L2 7.5L4 9V6ZM4 9L2 10.5L4 12V9ZM4 12L2 13.5L4 15V12ZM4 0H5V2H4V0ZM4 13H5V15H4V13ZM4 5H5V7H4V5ZM4 3H5V4H4V3ZM4 11H5V12H4V11ZM4 8H5V10H4V8Z"
                    fill="#AE6A3E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.236 3.014C11.323 3.004 11.411 3 11.5 3C12.88 3 14 4.12 14 5.5C14 6.88 12.88 8 11.5 8C10.12 8 9 6.88 9 5.5C9 5.41 9.005 5.323 9.014 5.236C9.13 6.23 9.974 7 11 7C12.105 7 13 6.105 13 5C13 3.975 12.23 3.13 11.236 3.014ZM10 4H11V5H10V4Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 4H9V5H8V4ZM10 2H11V3H10V2Z"
                    fill="#9EE2C0"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#EA0312"
                />
                <path
                    d="M10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 7H13V8H12V7Z"
                    fill="#EA0312"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.5 9C12.044 9.607 11.318 10 10.5 10C9.12 10 8 8.88 8 7.5C8 6.12 9.12 5 10.5 5C11.318 5 12.044 5.393 12.5 6H11C10.172 6 9.5 6.672 9.5 7.5C9.5 8.328 10.172 9 11 9H12.5Z"
                    fill="#EA0312"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TO = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#C80200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H11V9H0V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 4V2H5V4H3V6H5V8H7V6H9V4H7Z"
                    fill="#C80200"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TR = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#E70B17"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0019 8.65201L12.8399 9.262L13.0619 7.969L12.1219 7.052L13.4219 6.862L14.0019 5.686L14.5819 6.863L15.8819 7.053L14.9419 7.968L15.1639 9.261"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.5 11C11.433 11 13 9.433 13 7.5C13 5.567 11.433 4 9.5 4C7.567 4 6 5.567 6 7.5C6 9.433 7.567 11 9.5 11ZM10.5 10C11.88 10 13 8.88 13 7.5C13 6.12 11.88 5 10.5 5C9.12 5 8 6.12 8 7.5C8 8.88 9.12 10 10.5 10Z"
                    fill="white"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TT = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D4112A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 0L21 15H14L0 0H7Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 0L20 15H15L1 0H7H6Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TV = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#66A1BA"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 5V6H15V5H14ZM17 5V6H18V5H17ZM12 8V9H13V8H12ZM16 9V10H17V9H16ZM12 11V12H13V11H12ZM8 10V11H9V10H8Z"
                    fill="#FFD400"
                />
                <path
                    d="M9 1H2C1.44772 1 1 1.44772 1 2V7C1 7.55228 1.44772 8 2 8H9C9.55229 8 10 7.55228 10 7V2C10 1.44772 9.55229 1 9 1Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 5H2V4H5V2H6V4H9V5H6V7H5V5ZM7.5 6V7H9V6H7.5ZM7.5 2V3H9V2H7.5ZM2 6V7H3.5V6H2ZM2 2V3H3.5V2H2Z"
                    fill="#FF0000"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const TZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#20BD42"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15H21V2L0 13V15Z"
                    fill="#03ACE1"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 14L21 3V-1L0 10V14Z"
                    fill="#FCD715"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 16L21 5V1L0 12V16Z"
                    fill="#FCD715"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 15L21 4V0L0 11V15Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const UA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FFDA00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V8H0V0Z"
                    fill="#0266C3"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const UG = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FCE102"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V2H0V0Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4H21V7H0V4Z"
                    fill="#DE0200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 7H21V10H0V7Z"
                    fill="black"
                />
                <path
                    d="M20 12H1C0.447715 12 0 12.4477 0 13V14C0 14.5523 0.447715 15 1 15H20C20.5523 15 21 14.5523 21 14V13C21 12.4477 20.5523 12 20 12Z"
                    fill="#DE0200"
                />
                <path
                    d="M10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 4L9 7L10 9L11 7V10L12 7L11 6L10 7V4Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const US = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H9V7H0V0Z"
                    fill="#444379"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 1V2H2V1H1ZM3 1V2H4V1H3ZM5 1V2H6V1H5ZM7 1V2H8V1H7ZM6 2V3H7V2H6ZM4 2V3H5V2H4ZM2 2V3H3V2H2ZM1 3V4H2V3H1ZM3 3V4H4V3H3ZM5 3V4H6V3H5ZM7 3V4H8V3H7ZM1 5V6H2V5H1ZM3 5V6H4V5H3ZM5 5V6H6V5H5ZM7 5V6H8V5H7ZM6 4V5H7V4H6ZM4 4V5H5V4H4ZM2 4V5H3V4H2Z"
                    fill="#A7B6E7"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 0V1H21V0H9ZM9 2V3H21V2H9ZM9 4V5H21V4H9ZM9 6V7H21V6H9ZM0 8V9H21V8H0ZM0 10V11H21V10H0ZM0 12V13H21V12H0ZM0 14V15H21V14H0Z"
                    fill="#ED4C49"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const UY = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 3H21V5H10V3ZM10 7H21V9H10V7ZM0 11H21V13H0V11Z"
                    fill="#005CB2"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.88 6.88C6.65 8.125 6.12 9 5.5 9C4.88 9 4.35 8.126 4.12 6.88C2.875 6.65 2 6.12 2 5.5C2 4.88 2.874 4.35 4.12 4.12C4.35 2.875 4.88 2 5.5 2C6.12 2 6.65 2.874 6.88 4.12C8.125 4.35 9 4.88 9 5.5C9 6.12 8.126 6.65 6.88 6.88Z"
                    fill="#FFEA7B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.187 6.187C6.123 7.79 5.84 9 5.5 9C5.16 9 4.877 7.79 4.813 6.187C3.21 6.123 2 5.84 2 5.5C2 5.16 3.21 4.877 4.813 4.813C4.877 3.21 5.16 2 5.5 2C5.84 2 6.123 3.21 6.187 4.813C7.79 4.877 9 5.16 9 5.5C9 5.84 7.79 6.123 6.187 6.187Z"
                    fill="#FCD715"
                />
                <path
                    d="M5.5 7C6.32843 7 7 6.32843 7 5.5C7 4.67157 6.32843 4 5.5 4C4.67157 4 4 4.67157 4 5.5C4 6.32843 4.67157 7 5.5 7Z"
                    fill="#FCD715"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const UZ = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D4112A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 11H21V15H0V11Z"
                    fill="#20BD42"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V4H0V0Z"
                    fill="#02A3BD"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5H21V10H0V5ZM5 3.915C4.844 3.97 4.675 4 4.5 4C3.672 4 3 3.328 3 2.5C3 1.672 3.672 1 4.5 1C4.675 1 4.844 1.03 5 1.085C4.417 1.291 4 1.847 4 2.5C4 3.153 4.417 3.71 5 3.915Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 2H7V3H6V2ZM7 1H8V2H7V1ZM8 2H9V3H8V2ZM9 1H10V2H9V1ZM10 2H11V3H10V2ZM9 3H10V4H9V3ZM7 3H8V4H7V3Z"
                    fill="#78CDDB"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const VA = () => {
    return (
        <svg
            width="16"
            height="15"
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0)">
                <mask
                    id="mask0"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="21"
                    height="15"
                >
                    <path
                        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0H8V15H0V0Z"
                        fill="#FFE200"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 0H14C15.1046 0 16 0.895431 16 2V13C16 14.1046 15.1046 15 14 15H8V0Z"
                        fill="white"
                    />
                    <path d="M10 6L13 9" stroke="#CCCCCC" />
                    <path d="M11.5 7.5V10" stroke="#ED9069" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 6H13L11.5 4L10 6Z"
                        fill="#CF9E00"
                    />
                    <path d="M13 6L10 9" stroke="#CF9E00" />
                    <path
                        d="M14 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H14C14.8284 14.5 15.5 13.8284 15.5 13V2C15.5 1.17157 14.8284 0.5 14 0.5Z"
                        stroke="black"
                        strokeOpacity="0.1"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="16" height="15" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const VC = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#FCD715"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H6V15H0V0Z"
                    fill="#027DCD"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 0H21V15H15V0ZM8 7L9 5L10 7L9 9L8 7ZM11 7L12 5L13 7L12 9L11 7ZM9.5 9L10.5 7L11.5 9L10.5 11L9.5 9Z"
                    fill="#00A86B"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const VE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#00207F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 8H7V9H6V8ZM8 7H9V8H8V7ZM12 7H13V8H12V7ZM14 8H15V9H14V8ZM10 6H11V7H10V6Z"
                    fill="#BCC9F0"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#D10D24"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#FFCD00"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const VI = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.25 9L16 9.75L13.75 12L13 11.25L15.25 9Z"
                    fill="#0081C6"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.75 9L6 9.75L8.25 12L9 11.25L6.75 9Z"
                    fill="#369443"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 9H8V10L6 11L7 9Z"
                    fill="#F4C53D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 7H4V10H3V7ZM17 7H18V10H17V7Z"
                    fill="#0081C6"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 4V3H9V4L10 5V7H11V4ZM4 4L8 5V8L4 5V4ZM17 4L13 5V8L17 5V4ZM8 11L10.5 12L13 11L12 10H9L8 11Z"
                    fill="#F4C53D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 6H13V10L10.5 11L8 10V6Z"
                    fill="#A60032"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 5H13V7H8V5Z"
                    fill="#162667"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 7H10V10H9V7ZM11 7H12V10H11V7Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 9H13V10L15 11L14 9Z"
                    fill="#F4C53D"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const VN = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#DC220D"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5019 9.33L8.41195 10.43L8.81195 8.103L7.12195 6.456L9.45795 6.116L10.5019 4L11.5469 6.116L13.8819 6.456L12.1919 8.103L12.5919 10.429"
                    fill="#FFFF00"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const VU = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 9H21V15H0V9Z"
                    fill="#00963F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V6H0V0Z"
                    fill="#D4062E"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.208 9L2 15.033H0V0H2L9.2 6H21V9H9.208Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.9 8L0.5 15L0 15.033V0H0.5L8.9 7H21V8H8.9Z"
                    fill="#FECF00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 1L8 7.5L0 14V1Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.653 9.347C1.253 8.89 1 8.232 1 7.5C1 6.12 1.895 5 3 5C4.105 5 5 6.12 5 7.5C5 8.88 4.105 10 3 10V9C3.552 9 4 8.328 4 7.5C4 6.672 3.552 6 3 6C2.448 6 2 6.672 2 7.5C2 7.96 2.138 8.37 2.354 8.646L1.654 9.346L1.653 9.347Z"
                    fill="#FECF00"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const WS = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#D4112A"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H11V8H0V0Z"
                    fill="#02308A"
                />
            </g>
            <mask
                id="mask1"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask1)">
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
                <path
                    opacity="0.5"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 2H6V3H5V2ZM7 3H8V4H7V3ZM6 4H7V5H6V4ZM5 5H6V6H5V5ZM4 3H5V4H4V3Z"
                    fill="white"
                />
            </g>
        </svg>
    )
}

export const YE = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#D0091E"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ZA = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10H21V15H0V10Z"
                    fill="#02269F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0H21V5H0V0Z"
                    fill="#E24038"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.013 10L2 15.033H0V0H2L8 5H21V10H8.013Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.7 9L0.5 15L0 15.033V0H0.5L7.7 6H21V9H7.7Z"
                    fill="#008557"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 3L6 7.5L0 12V3Z"
                    fill="#FFBE0F"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4L4.75 7.5L0 11V4Z"
                    fill="black"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ZM = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#0D8B00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19 6H21V15H19V6Z"
                    fill="#F17D00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17 6H19V15H17V6Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 6H17V15H15V6Z"
                    fill="#E11C00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 3L17 4L18 5L19 4L22 3H18L17 2V3H14Z"
                    fill="#F17D00"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}

export const ZW = () => {
    return (
        <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="15"
            >
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                    fill="#2B9300"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 2H21V13H0V2Z"
                    fill="#FFD300"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4H21V11H0V4Z"
                    fill="#E11C00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 6H21V9H0V6Z"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 0L12 7.5L1 15H0V0"
                    fill="black"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0L11 7.5L0 15V0Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.49995 8.75L3.02995 9.523L3.30995 7.886L2.12195 6.726L3.76495 6.489L4.49995 5L5.23495 6.49L6.87795 6.727L5.68795 7.887L5.96795 9.523"
                    fill="#E11C00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 9H6V8L5 7C5 7 5 6 4 6H3L4 7L3 9Z"
                    fill="#FFC700"
                />
                <path
                    d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
                    stroke="black"
                    strokeOpacity="0.1"
                />
            </g>
        </svg>
    )
}
